<template>
  <div>
    <b-modal
      id="modal-login"
      cancel-variant="outline-secondary"
      :ok-title="$t('Show data')"
      hide-footer
      centered
      no-close-on-backdrop
      :title="$t('Filters')"
    >
      <b-form>
        <b-form-group
          v-if="reportDomain == 'myskoolhpgs' && $store.state.userData.cId == 1"
          :label="$t('Campus')"
          :invalid-feedback="$t('Campus is required')"
          ref="camp"
        >
          <v-select
            v-model="filter.cID"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="campuses"
            :clearable="false"
            :reduce="(val) => val.id"
            label="branch"
            :disabled="filterloading"
            :placeholder="$t('Select campus')"
          />
        </b-form-group>

        <b-form-group
          :label="$t('Department')"
          :invalid-feedback="$t('Department is required')"
          ref="dep"
        >
          <v-select
            v-model="filter.dep"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="[{ name: 'All Departments', id: 0 }, ...departments]"
            :clearable="false"
            label="name"
            :reduce="(val) => val.id"
            ref="dep"
            :disabled="filterloading"
            :placeholder="$t('Select department')"
          />
        </b-form-group>

        <b-form-group
          :label="$t('Status')"
          :invalid-feedback="$t('Status is required')"
          ref="status"
        >
          <v-select
            v-model="currentStatus"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="statusOptions"
            :reduce="(opt) => opt.value"
            label="text"
            :clearable="false"
            :disabled="filterloading"
            :placeholder="$t('Select status')"
          />
        </b-form-group>

        <b-form-group
          :label="$t('Appointed Date From')"
          :invalid-feedback="$t('Date is required')"
          ref="appointed_from"
        >
          <flat-pickr
            :config="config"
            v-model="filter.appointedFrom"
            class="form-control"
            :placeholder="$t('Select from date')"
          />
        </b-form-group>

        <b-form-group
          :label="$t('Appointed Date To')"
          :invalid-feedback="$t('Date is required')"
          ref="appointed_to"
        >
          <flat-pickr
            :config="config"
            v-model="filter.appointedTo"
            class="form-control"
            :placeholder="$t('Select to date')"
          />
        </b-form-group>

        <b-form-group
          :label="$t('Leaving Date From')"
          :invalid-feedback="$t('Date is required')"
          ref="leaving_from"
        >
          <flat-pickr
            :config="config"
            v-model="filter.leavingFrom"
            class="form-control"
            :placeholder="$t('Select leaving from date')"
          />
        </b-form-group>

        <b-form-group
          :label="$t('Leaving Date To')"
          :invalid-feedback="$t('Date is required')"
          ref="leaving_to"
        >
          <flat-pickr
            :config="config"
            v-model="filter.leavingTo"
            class="form-control"
            :placeholder="$t('Select leaving to date')"
          />
        </b-form-group>

        <b-form-group
          :label="$t('Designation')"
          :invalid-feedback="$t('Designation is required')"
          ref="designation_filter"
        >
          <v-select
            v-if="designationOptionsForFilter && designationOptionsForFilter.length > 0"
            v-model="filter.designation"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="designationOptionsForFilter"
            :clearable="true"
            :disabled="filterloading"
            :placeholder="$t('Select designation')"
          />
          <b-form-input
            v-else
            v-model.trim="filter.designation"
            :placeholder="$t('Enter designation')"
            :disabled="filterloading"
          />
        </b-form-group>

        <b-form-group
          :label="$t('Gender')"
          :invalid-feedback="$t('Gender is required')"
          ref="gender_filter"
        >
          <v-select
            v-model="filter.gender"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="genderFilterOptions"
            :reduce="(opt) => opt.value"
            label="text"
            :clearable="false"
            :disabled="filterloading"
            :placeholder="$t('Select gender')"
          />
        </b-form-group>
      </b-form>
      <b-row class="mt-2">
        <b-col class="d-flex justify-content-end">
          <!-- @click="Filter()" -->
          <b-button
            @click="resetFilters()"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mr-2"
          >
            <span class="align-middle">{{ $t("Reset") }}</span>
          </b-button>
          <b-button
            @click="LoadData('filter')"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
          >
            <span class="align-middle">{{ $t("Show data") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="modal-cards"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      no-close-on-backdrop
      :title="$t('Print ID Card')"
    >
      <b-form>
        <b-form-group
          :label="$t('Department')"
          :invalid-feedback="$t('Department is required')"
          ref="card_dep"
        >
          <v-select
            ref="card_dep"
            v-model="cardObj.depList"
            multiple
            :closeOnSelect="false"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="departments"
            :clearable="false"
            label="name"
            :reduce="(val) => val.id"
            :disabled="filterloading"
            :placeholder="$t('Select department')"
            @input="setDep()"
          />
        </b-form-group>
      </b-form>
      <b-row class="mt-2">
        <b-col class="d-flex justify-content-end">
          <b-button
            @click="printByDep()"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            :disabled="printing"
          >
            <span class="align-middle">{{ $t("Print") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="modal-kent-staff-print"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      no-close-on-backdrop
      :title="$t('Print')"
    >
      <b-form>
        <b-form-group
          :label="$t('Type')"
          :invalid-feedback="$t('Type is required')"
          ref="kent_print_type"
        >
          <v-select
            ref="kent_print_type"
            v-model="kentPrintObj.type"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="kentStaffPrintOptionsForGrid"
            :clearable="false"
            label="name"
            :reduce="(val) => val.value"
            :placeholder="$t('Select type')"
          />
        </b-form-group>
        <b-form-group
          v-if="
            kentPrintObj.type !== 'id-card' ||
            persistentSelectedIds.length === 0
          "
          :label="$t('Department')"
          :invalid-feedback="$t('Department is required')"
          ref="kent_print_dep"
        >
          <v-select
            ref="kent_print_dep"
            v-model="kentPrintObj.depList"
            multiple
            :closeOnSelect="false"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="[{ name: 'All Departments', id: 0 }, ...departments]"
            :clearable="false"
            label="name"
            :reduce="(val) => val.id"
            :placeholder="$t('Select department')"
            @input="setKentPrintDep()"
          />
        </b-form-group>
        <p
          v-if="persistentSelectedIds.length > 0"
          class="text-muted small mb-0"
        >
          {{ persistentSelectedIds.length }}
          {{ $t("staff selected on grid — print uses selection.") }}
        </p>
      </b-form>
      <b-row class="mt-2">
        <b-col class="d-flex justify-content-end">
          <b-button
            @click="printKentStaffReport()"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            :disabled="printing"
          >
            <b-spinner v-if="printing" small type="grow" class="mr-50" />
            <span class="align-middle">{{ $t("Print") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="modal-general-staff-print"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      no-close-on-backdrop
      :title="$t('Print')"
    >
      <b-form>
        <b-form-group
          :label="$t('Type')"
          :invalid-feedback="$t('Type is required')"
          ref="general_print_type"
        >
          <v-select
            ref="general_print_type"
            v-model="generalPrintObj.type"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="generalStaffPrintOptions"
            :clearable="false"
            label="name"
            :reduce="(val) => val.value"
            :placeholder="$t('Select type')"
          />
        </b-form-group>
        <b-form-group
          v-if="generalPrintObj.type !== 'id-card'"
          :label="$t('Department')"
          :invalid-feedback="$t('Department is required')"
          ref="general_print_dep"
        >
          <v-select
            ref="general_print_dep"
            v-model="generalPrintObj.depList"
            multiple
            :closeOnSelect="false"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="[{ name: 'All Departments', id: 0 }, ...departments]"
            :clearable="false"
            label="name"
            :reduce="(val) => val.id"
            :placeholder="$t('Select department')"
            @input="setGeneralPrintDep()"
          />
        </b-form-group>
        <p
          v-if="
            generalPrintObj.type !== 'id-card' &&
            persistentSelectedIds.length > 0
          "
          class="text-muted small mb-0"
        >
          {{ persistentSelectedIds.length }}
          {{ $t("staff selected on grid — print uses selection.") }}
        </p>
      </b-form>
      <b-row class="mt-2">
        <b-col class="d-flex justify-content-end">
          <b-button
            @click="printGeneralStaffReport()"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            :disabled="printing"
          >
            <b-spinner v-if="printing" small type="grow" class="mr-50" />
            <span class="align-middle">{{ $t("Print") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="modal-report"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      no-close-on-backdrop
      :title="$t('Print Subject List')"
    >
      <b-form>
        <b-form-group
          v-if="persistentSelectedIds.length == 0"
          :label="$t('Department')"
          :invalid-feedback="$t('Department is required')"
          ref="rep_dep"
        >
          <v-select
            v-model="repObj.depList"
            multiple
            :closeOnSelect="false"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="departments"
            :clearable="false"
            label="name"
            :reduce="(val) => val.id"
            :placeholder="$t('Select department')"
            @input="setRepDep()"
          />
        </b-form-group>

        <b-form-group
          :label="$t('Student Session')"
          :invalid-feedback="$t('Session is required')"
          ref="rep_session"
        >
          <v-select
            v-model="repObj.sessionID"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="sessionOptions"
            :reduce="(opt) => opt.id"
            label="session"
            :clearable="false"
            :placeholder="$t('Select session')"
          />
        </b-form-group>

        <b-form-group
          :label="$t('Student Status')"
          :invalid-feedback="$t('Status is required')"
          ref="rep_status"
        >
          <v-select
            v-model="repObj.status"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="studentStatusOptions"
            :reduce="(opt) => opt.value"
            label="text"
            :clearable="false"
            :placeholder="$t('Select status')"
          />
        </b-form-group>

        <b-form-checkbox
          v-model="repObj.format"
          value="no-fees"
          unchecked-value=""
        >
          <span>{{ $t("Hide Fees") }}</span>
        </b-form-checkbox>
      </b-form>
      <b-row class="mt-2">
        <b-col class="d-flex justify-content-end">
          <b-button
            @click="printReport(false)"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="repExporting"
          >
            <span class="align-middle">{{ $t("Print") }}</span>
          </b-button>
          <b-button
            @click="printReport(true)"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="warning"
            :disabled="repExporting"
          >
            <span class="align-middle">{{ $t("Export") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <div>
      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="visibility"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
        @hidden="setFocus()"
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">{{ $t("Import") }}</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibility = false"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row class="">
            <b-col md="12" class="pt-1">
              <b-button
                @click="$refs.importStaff.click()"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                :disabled="staffImporting"
                block
              >
                <b-spinner
                  v-if="staffImporting"
                  small
                  variant="light"
                  label="Spinning"
                ></b-spinner>
                <div v-else>
                  <input
                    type="file"
                    id="importStaff"
                    hidden
                    ref="importStaff"
                    @change="ImportStaff()"
                  />
                  <feather-icon icon="PlusIcon" class="mr-50" />
                  <span class="align-middle">{{ $t("Staff") }}</span>
                </div>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-sidebar>

      <b-sidebar
        id="sidebar-increment-menu"
        bg-variant="white"
        v-model="visibilityIncrementMenu"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
        @hidden="setFocus()"
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">{{ $t("Bulk Increment") }}</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibilityIncrementMenu = false"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row>
            <b-col md="12" class="mb-1">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                block
                @click="openBulkIncrementModal()"
              >
                <feather-icon icon="TrendingUpIcon" class="mr-50" />
                <span class="align-middle">{{ $t("Bulk Increment") }}</span>
              </b-button>
            </b-col>
            <b-col md="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                block
                @click="openBulkImportIncrementModal()"
              >
                <feather-icon icon="UploadCloudIcon" class="mr-50" />
                <span class="align-middle">{{ $t("Bulk Import") }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-sidebar>

      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="visibility2"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
        @hidden="setFocus()"
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">{{ $t("Staff Left") }}</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibility2 = false"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row class="">
            <b-col md="12">
              <b-form-group
                :label="$t('Leaving Date')"
                :invalid-feedback="$t('Date is required')"
                ref="left_date"
              >
                <flat-pickr
                  :config="leavingDateConfig"
                  v-model="myObj.leaving_date"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group :label="$t('Leaving Category')">
                <v-select
                  v-model="myObj.leavingCategory"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="leavingCategoryOptions"
                  :reduce="(opt) => opt.value"
                  label="text"
                  :placeholder="$t('Select category')"
                  @input="onLeavingCategoryChange"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group :label="$t('Leaving Reason')">
                <v-select
                  v-if="usesStructuredLeavingReasons"
                  v-model="myObj.leavingReason"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="leavingReasonOptions"
                  :reduce="(opt) => opt.value"
                  label="text"
                  :placeholder="$t('Select reason')"
                  :disabled="!myObj.leavingCategory"
                  @input="onLeavingReasonChange"
                />
                <b-form-textarea
                  v-else
                  v-model.trim="myObj.leavingReason"
                  :placeholder="$t('Enter reason')"
                  rows="3"
                />
              </b-form-group>
            </b-col>
            <b-col
              md="12"
              v-if="usesStructuredLeavingReasons && isOtherLeavingReason"
            >
              <b-form-group :label="$t('Specify Reason')">
                <b-form-textarea
                  v-model.trim="leavingReasonOther"
                  :placeholder="$t('Enter reason')"
                  rows="3"
                />
              </b-form-group>
            </b-col>
            <b-col md="12" class="pt-1">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                :disabled="saving"
                block
                @click="markLeft()"
              >
                <b-spinner
                  v-if="saving"
                  small
                  variant="light"
                  label="Spinning"
                ></b-spinner>
                <span v-else>{{ $t("Mark Left") }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-sidebar>

      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="visibility3"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
        @hidden="setFocus()"
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">{{ $t("Staff Readmit") }}</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibility3 = false"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row class="">
            <b-col md="12">
              <b-form-group
                :label="$t('Leaving Date')"
                :invalid-feedback="$t('Date is required')"
              >
                <flat-pickr
                  :config="config"
                  v-model="myObj.leaving_date"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                  disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                :label="$t('Readmit Date')"
                :invalid-feedback="$t('Date is required')"
                ref="readmit_date"
              >
                <flat-pickr
                  :config="config"
                  v-model="myObj.rejoining_date"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>
            <b-col md="12" class="pt-1">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                :disabled="saving || savingRej"
                block
                @click="markReadmit(false)"
              >
                <b-spinner
                  v-if="saving"
                  small
                  variant="light"
                  label="Spinning"
                ></b-spinner>
                <span v-else>{{ $t("Readmit") }}</span>
              </b-button>
            </b-col>
            <b-col md="12" class="mt-1">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                :disabled="saving || savingRej"
                block
                @click="markReadmit(true)"
              >
                <b-spinner
                  v-if="savingRej"
                  small
                  variant="light"
                  label="Spinning"
                ></b-spinner>
                <span v-else>{{ $t("Rejoin") }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-sidebar>

      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="visibility4"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
        @hidden="setFocus()"
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0">{{ $t("Transfer Staff") }}</h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibility4 = false"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row class="">
            <b-col md="12" class="mb-1">
              <b-media vertical-align="center">
                <template #aside>
                  <b-avatar
                    size="44"
                    :src="getPicturePreview(currentStaff.picture)"
                    variant="light-primary"
                    referrerpolicy="no-referrer"
                  />
                </template>

                <b-link class="font-weight-bold d-block text-nowrap mb-25">
                  <b-badge variant="light-primary">
                    {{ currentStaff.name }}
                  </b-badge>
                </b-link>
                <b-link class="font-weight-bold d-block text-nowrap mb-25">
                  <b-badge variant="light-primary">
                    F/N: {{ currentStaff.father_name }}
                  </b-badge>
                </b-link>
                <b-link class="font-weight-bold d-block text-nowrap">
                  <b-badge variant="light-primary">
                    {{ currentStaff.designation }}
                  </b-badge>
                </b-link>
              </b-media>
            </b-col>
            <b-col cols="12">
              <b-form-group :label="$t('Current Campus')">
                <b-badge variant="primary">
                  {{ getCampus(currentStaff.campusID) }}
                </b-badge>
              </b-form-group>
              <b-form-group :label="$t('Current Department')">
                <b-badge variant="primary">
                  {{ getDepName(currentStaff.departmentID) }}
                </b-badge>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                :label="$t('Transfer to Campus')"
                :invalid-feedback="$t('Campus is required')"
                ref="ch_camp"
              >
                <v-select
                  v-model="campObj.newCampus"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="campuses"
                  :clearable="false"
                  label="branch"
                  :reduce="(val) => val.id"
                  :placeholder="$t('Select campus')"
                  @input="LoadDepByCamp()"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                :label="$t('Department')"
                :invalid-feedback="$t('Department is required')"
                ref="ch_dep"
              >
                <v-select
                  v-model="campObj.departmentID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="depOptions"
                  :clearable="false"
                  label="name"
                  :reduce="(val) => val.id"
                  :disabled="depLoading"
                  :placeholder="$t('Select department')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                :label="$t('Designation')"
                :invalid-feedback="$t('Designation is required')"
                ref="ch_des"
              >
                <v-select
                  v-if="campDesignationOptions && campDesignationOptions.length > 0"
                  v-model="campObj.designation"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="campDesignationOptions"
                  :clearable="true"
                  :placeholder="$t('Select designation')"
                />
                <b-form-input
                  v-else
                  v-model.trim="campObj.designation"
                  :placeholder="$t('Enter designation')"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                :label="$t('Transfer Date')"
                :invalid-feedback="$t('Date is required')"
                ref="ch_date"
              >
                <flat-pickr
                  :config="config"
                  v-model="campObj.date"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>

            <b-col class="mt-1" md="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="success"
                class="mr-1"
                block
                :disabled="request"
                @click="saveCh()"
              >
                <b-spinner v-if="request" small type="grow" />
                <span v-else>{{ $t("Transfer") }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-sidebar>

      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="visibility5"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
        @hidden="setFocus()"
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0" v-html="sidebarTitle"></h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibility5 = false"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row class="">
            <b-table
              v-if="reqData.length > 0"
              show-empty
              :items="reqData"
              :fields="reqFields"
              responsive
              hover
              small
            >
              <template #head()="scope">
                <div>
                  <span>{{ $t(scope.label) }}</span>
                </div>
              </template>

              <template #cell(request)="data">
                <div class="mb-25">
                  <b-badge variant="light-primary">
                    ID: {{ data.item.id }}
                  </b-badge>
                </div>
                <div>
                  <b-badge variant="light-primary">
                    {{
                      new Date(data.item.requestedOn).toLocaleDateString(
                        "en-UK",
                        {
                          year: "numeric",
                          day: "numeric",
                          month: "short",
                        }
                      )
                    }}
                  </b-badge>
                </div>
              </template>

              <template #cell(requestCategory)="data">
                <b-badge
                  variant="light-primary"
                  class="text-capitalize text-wrap"
                >
                  {{ data.value }}
                </b-badge>
              </template>

              <template #cell(actions)="data">
                <b-button
                  variant="primary"
                  class="btn-icon"
                  @click="showReqDetails(data.item)"
                >
                  <feather-icon icon="EyeIcon" />
                </b-button>
              </template>
            </b-table>

            <b-col cols="12">
              <b-form-group
                :label="$t('Request on')"
                :invalid-feedback="$t('Date is required')"
                ref="req_date"
              >
                <flat-pickr
                  :config="config"
                  v-model="reqObj.requestedOn"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                :label="$t('Reason')"
                :invalid-feedback="$t('Reason is required')"
                ref="req_reason"
              >
                <b-form-textarea
                  :placeholder="$t('Enter reason')"
                  rows="3"
                  v-model.trim="reqObj.request"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                :label="$t('Request Type')"
                :invalid-feedback="$t('Type is required')"
                ref="req_st"
              >
                <v-select
                  v-model="reqObj.requestCategory"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="requestOptions"
                  :reduce="(opt) => opt.value"
                  label="text"
                  :clearable="false"
                  :placeholder="$t('Select status')"
                />
              </b-form-group>
            </b-col>

            <b-col cols="12" class="mt-1 mb-1">
              <label>{{ $t("Attachments") }}</label>
              <div class="d-flex flex-wrap">
                <div
                  class="border-dashed d-flex flex-column justify-content-center align-items-center cursor-pointer rounded mr-50 mb-1"
                  style="width: 110px; height: 96px"
                  @click="!docLoading && $refs.reqDocs.click()"
                >
                  <b-spinner
                    v-if="docLoading"
                    small
                    :label="$t('Loading') + '...'"
                    variant="primary"
                  />
                  <feather-icon
                    v-else
                    icon="PlusIcon"
                    size="34"
                    class="text-primary"
                  />
                </div>
                <div
                  class="border-dashed d-flex flex-column justify-content-center align-items-center cursor-pointer rounded mr-50 mb-1"
                  style="width: 110px; height: 96px; position: relative"
                  v-for="(file, index) in docList"
                  :key="index"
                  @click="openFile(file)"
                >
                  <b-avatar
                    size="20"
                    variant="primary"
                    style="position: absolute; top: -5px; right: -5px"
                    button
                    @click.stop="removeDoc(index)"
                  >
                    <feather-icon icon="XIcon" />
                  </b-avatar>
                  <feather-icon
                    :icon="isImage(file) ? 'ImageIcon' : 'FileTextIcon'"
                    size="30"
                    class="text-primary"
                  />
                </div>

                <input
                  type="file"
                  id="reqDocs"
                  hidden
                  ref="reqDocs"
                  multiple
                  @change="addDoc()"
                  accept="image/*,.pdf"
                />
              </div>
            </b-col>

            <b-col class="mt-1" md="12">
              <b-button
                variant="success"
                :disabled="savingReq"
                block
                @click="saveLeaveReq()"
              >
                <b-spinner v-if="savingReq" small type="grow" />
                <span v-else> {{ $t("Save") }} </span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-sidebar>

      <b-sidebar
        id="sidebar-right"
        ref="mySidebar"
        bg-variant="white"
        v-model="visibility6"
        sidebar-class="sidebar-lg"
        right
        no-header
        backdrop
        shadow
      >
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h5 class="mb-0" v-html="sidebarTitle"></h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="visibility6 = false"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <RequestDetails :reqItem="detailObj" />
        </b-form>
      </b-sidebar>

      <b-card>
        <b-row class="mt-1 mb-3 toolbar-row">
          <b-col xl="2" lg="3" md="4" sm="12" cols="12" v-if="rights.add">
            <b-button
              class=""
              @click="AddOpen()"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              block
            >
              <feather-icon icon="PlusIcon" class="mr-50" />
              <span class="align-middle">{{ $t("Add Staff") }}</span>
            </b-button>
          </b-col>

          <b-col
            class="mt-lg-0 mt-md-0 mt-sm-1 mt-1 d-flex align-items-end"
            xl="6"
            lg="3"
            md="4"
            sm="12"
            cols="12"
          >
            <b-form-group class="ml-lg-2 ml-md-0 ml-sm-0 ml-0 w-100 mb-0">
              <b-input-group>
                <b-input-group-prepend is-text @click="loadSearch()">
                  <feather-icon icon="SearchIcon" />
                </b-input-group-prepend>

                <b-form-input
                  ref="searchInput"
                  v-model.trim="searchQuery"
                  :placeholder="$t('Search') + '...'"
                  @keyup.enter="loadSearch()"
                >
                </b-form-input>

                <b-input-group-append
                  v-if="!['myskoolhpgs'].includes(reportDomain)"
                >
                  <b-dropdown
                    variant="primary"
                    boundary="viewport"
                    class="search-criteria-dropdown"
                    size="md"
                    no-caret
                  >
                    <template #button-content>
                      {{ $t(selectedSearchCriteria.text) }}
                      <feather-icon
                        icon="ChevronDownIcon"
                        size="14"
                        class="ml-1"
                      />
                    </template>
                    <b-dropdown-header class="text-dark">
                      {{ $t("Choose Search Criteria") }}
                    </b-dropdown-header>
                    <b-dropdown-item
                      v-for="criteria in searchCriteriaOptions"
                      :key="criteria.value"
                      @click="selectSearchCriteria(criteria)"
                      :active="selectedSearchCriteria.value === criteria.value"
                      class="search-criteria-item"
                    >
                      <div class="d-flex flex-column">
                        <strong>{{ $t(criteria.text) }}</strong>
                        <small class="text-muted">{{
                          $t(criteria.description)
                        }}</small>
                      </div>
                    </b-dropdown-item>
                  </b-dropdown>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col
            class="d-flex align-items-end"
            xl="2"
            lg="3"
            md="4"
            sm="12"
            cols="12"
          >
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              v-b-modal.modal-login
              block
              class="filter-button"
            >
              <feather-icon icon="FilterIcon" class="mr-50" />
              <span class="align-middle">{{ $t("Filter") }}</span>
            </b-button>
          </b-col>
          <b-col
            xl="2"
            lg="3"
            md="12"
            sm="12"
            cols="12"
            class="pl-lg-0 pr-50 mt-lg-0 mt-md-0 mt-sm-1 mt-1 d-flex justify-content-between align-items-end"
          >
            <b-form-group
              label=""
              style="flex: 1"
              class="ml-md-0 ml-sm-0 ml-0 mb-0 pr-50"
            >
              <v-select
                v-model="currentStatus"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="statusOptions"
                :reduce="(opt) => opt.value"
                label="text"
                @input="LoadData('dd')"
                :clearable="false"
                :placeholder="$t('Select status')"
              />
            </b-form-group>
            <b-button
              v-if="!rights.disableImport"
              @click="OpenImport()"
              variant="outline-primary"
              class="btn-icon"
              v-b-tooltip.hover.top
              :title="$t('Import')"
            >
              <feather-icon icon="DownloadIcon" class="" />
            </b-button>
            <b-button
              v-if="!rights.disableExport"
              variant="outline-primary"
              v-b-tooltip.hover.top
              :title="$t('Export')"
              class="btn-icon ml-50"
              :disabled="exporting"
              @click="exportData()"
            >
              <b-spinner v-if="exporting" small varaint="primary" />
              <feather-icon v-else icon="UploadIcon" class="" />
            </b-button>
          </b-col>
        </b-row>

        <b-row class="mt-lg-0 mt-md-1 mt-sm-1 mb-1">
          <b-col cols="12" md="12" sm="12" class="text-right pl-0 mt-1 mt-sm-0">
            <!-- <b-button
              @click="updatePolicy()"
              variant="outline-success"
              class="btn-icon mr-1"
              :disabled="updatingPolicy"
              v-b-tooltip.hover.top
              title="Update Policy and Salary"
              style="border-color: #28a745; color: #28a745;"
            >
              <b-spinner
                v-if="updatingPolicy"
                variant="success"
                label="loading"
                small
              ></b-spinner>

              <span v-if="!updatingPolicy">
                <feather-icon icon="SettingsIcon" class="mr-50" /> Update Policy
              </span>
            </b-button> -->
            <b-button
              @click="printFileCovers()"
              variant="outline-secondary"
              class="btn-icon mr-1"
              :disabled="printing"
              v-b-tooltip.hover.top
              :title="$t('Print File Covers')"
              style="border-color: #6c757d; color: #6c757d"
            >
              <b-spinner
                v-if="printing"
                variant="secondary"
                label="loading"
                small
              ></b-spinner>

              <span v-if="!printing">
                <feather-icon icon="FileIcon" class="mr-50" />
                {{ $t("File Cover") }}
              </span>
              <span v-if="!printing && persistentSelectedIds.length > 0"
                >({{ persistentSelectedIds.length }})</span
              >
            </b-button>

            <b-dropdown
              v-if="['myskooliuss'].includes(reportDomain)"
              toggle-class="btn-icon"
              variant="outline-primary"
              right
              no-caret
            >
              <template #button-content>
                <span v-if="!printing">
                  <feather-icon icon="PrinterIcon" class="mr-50" />
                  {{ $t("Print") }}
                </span>
                <span v-if="!printing && persistentSelectedIds.length > 0"
                  >({{ persistentSelectedIds.length }})</span
                >
              </template>
              <b-dropdown-item
                v-for="opt in reportOptions"
                :key="opt.name"
                @click="reportSelected(opt.value)"
              >
                {{ opt.name }}
              </b-dropdown-item>
            </b-dropdown>
            <b-button
              v-else-if="usesCampusBrandedStaffIdCardPrint"
              @click="openKentStaffPrint()"
              variant="outline-primary"
              class="btn-icon"
              :disabled="printing"
            >
              <b-spinner
                v-if="printing"
                variant="primary"
                label="loading"
                small
              ></b-spinner>

              <span v-if="!printing">
                <feather-icon icon="PrinterIcon" class="mr-50" />
                {{ $t("Print") }}
              </span>
              <span v-if="!printing && persistentSelectedIds.length > 0"
                >({{ persistentSelectedIds.length }})</span
              >
            </b-button>
            <b-button
              v-else-if="['myskoolveritas', 'myskoolskh'].includes(reportDomain)"
              @click="openGeneralStaffPrint()"
              variant="outline-primary"
              class="btn-icon"
              :disabled="printing"
            >
              <b-spinner
                v-if="printing"
                variant="primary"
                label="loading"
                small
              ></b-spinner>

              <span v-if="!printing">
                <feather-icon icon="PrinterIcon" class="mr-50" />
                {{ $t("Print") }}
              </span>
              <span v-if="!printing && persistentSelectedIds.length > 0"
                >({{ persistentSelectedIds.length }})</span
              >
            </b-button>
            <b-button
              v-else
              @click="printIDs()"
              variant="outline-primary"
              class="btn-icon"
              :disabled="printing"
            >
              <b-spinner
                v-if="printing"
                variant="primary"
                label="loading"
                small
              ></b-spinner>

              <span v-if="!printing">
                <feather-icon icon="PrinterIcon" class="mr-50" />
                {{ $t("Print") }}
              </span>
              <span v-if="!printing && persistentSelectedIds.length > 0"
                >({{ persistentSelectedIds.length }})</span
              >
            </b-button>

            <b-button
              v-if="
                persistentSelectedIds.length > 0 &&
                templateLink &&
                templateLink.value == 'template_link'
              "
              @click="openTemplateModal()"
              variant="outline-success"
              class="btn-icon ml-1"
              :disabled="printing"
            >
              <feather-icon icon="FileTextIcon" class="mr-50" />
              <span>{{ $t("Select Template") }}</span>
              <span>({{ persistentSelectedIds.length }})</span>
            </b-button>
            <b-button
              v-if="reportDomain == 'myskoolskh'"
              @click="openReport()"
              variant="outline-primary"
              class="btn-icon ml-1"
              :disabled="printing"
              v-b-tooltip.hover.top
              :title="$t('Subject List')"
            >
              <feather-icon icon="FileTextIcon" />
              <span v-if="persistentSelectedIds.length > 0"
                >({{ persistentSelectedIds.length }})</span
              >
            </b-button>
            <b-button
              v-if="persistentSelectedIds.length > 0"
              @click="unselect()"
              variant="outline-secondary"
              class="btn-icon ml-1"
              :disabled="printing"
            >
              <feather-icon icon="XIcon" class="mr-50" />
              <span>{{ $t("Unselect All") }}</span>
            </b-button>
            <b-button
              @click="syncApp()"
              variant="outline-primary"
              class="btn-icon ml-1"
              :disabled="syncLoading"
              v-b-tooltip.hover.top
              :title="$t('Sync App Accounts')"
            >
              <b-spinner
                v-if="syncLoading"
                variant="primary"
                label="loading"
                small
              ></b-spinner>
              <feather-icon v-else icon="SmartphoneIcon" class="" />
            </b-button>
            <b-button
              @click="openColumnSettings()"
              variant="outline-primary"
              class="btn-icon ml-1"
              v-b-tooltip.hover.top
              :title="$t('Column Settings')"
            >
              <feather-icon icon="SettingsIcon" class="" />
            </b-button>
            <b-button
              v-if="showDesignationSettings"
              @click="openDesignationSettings()"
              variant="outline-primary"
              class="btn-icon ml-1"
              v-b-tooltip.hover.top
              :title="$t('Designation Settings')"
            >
              <feather-icon icon="UserCheckIcon" class="" />
            </b-button>
            <b-button
              v-if="showBulkIncrement"
              variant="outline-primary"
              class="btn-icon ml-1"
              v-b-tooltip.hover.top
              :title="$t('Bulk Increment')"
              @click="openIncrementMenu()"
            >
              <feather-icon icon="TrendingUpIcon" class="" />
            </b-button>
          </b-col>
        </b-row>

        <!-- rotate-table -->
        <b-table
          class="mt-1"
          :busy="dataLoading"
          ref="selectableTable"
          :items="items"
          :fields="displayFields"
          show-empty
          responsive
          hover
          small
          :selectable="rights.edit"
          select-mode="multi"
          @row-selected="staffSelect($event)"
          @head-clicked="handleSort"
        >
          <template #empty>
            <h3 class="mt-1 mb-1 text-center">{{ $t("No records found") }}</h3>
          </template>
          <template #table-busy>
            <div class="d-flex justify-content-center mb-3 mt-5">
              <b-spinner
                style="width: 3rem; height: 3rem"
                type="grow"
                variant="primary"
                label="Spinning"
              ></b-spinner>
            </div>
          </template>

          <template #head()="scope">
            <div>
              <span>{{ $t(scope.label) }}</span>
            </div>
          </template>

          <template #cell(index)="data">
            <!-- {{ data.index + 1 }} -->
            <b-badge variant="light-primary">
              <!-- {{ filters.indexOf(data.item) + 1 }} -->
              {{ (currentPage - 1) * perPage + data.index + 1 }}
            </b-badge>
          </template>

          <template #cell(name)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                  size="44"
                  :src="getPicturePreview(data.item.picture)"
                  variant="light-primary"
                  referrerpolicy="no-referrer"
                  :to="
                    rights.edit
                      ? (data.item.status || '').toLowerCase() == 'applicant'
                        ? {
                            name: 'staff-application',
                            params: {
                              id: data.item.id,
                            },
                          }
                        : {
                            name: rights.singlePage
                              ? 'manage-staff-accounts'
                              : 'manage-staff',
                            params: {
                              id: data.item.id,
                            },
                          }
                      : ''
                  "
                />
              </template>

              <b-link class="font-weight-bold d-block text-nowrap mb-25">
                <b-badge variant="light-primary" class="font-small-4">
                  {{ data.item.name }}
                </b-badge>
              </b-link>
              <b-link class="font-weight-bold d-block text-nowrap mb-25">
                <b-badge variant="light-primary">
                  F/N: {{ data.item.father_name }}
                </b-badge>
              </b-link>
              <small class="text-muted">
                <b-badge variant="light-primary" class="mr-50">
                  ID: {{ data.item.id }}
                </b-badge>
                <b-badge variant="light-primary">
                  RFID: {{ data.item.rfID }}
                </b-badge>

                <b-badge
                  v-if="reportDomain == 'myskooliuss'"
                  :variant="
                    data.item.empCodeStr && data.item.empCodeStr !== '0'
                      ? 'light-primary'
                      : 'light-danger'
                  "
                  class="ml-50"
                >
                  EX: {{ data.item.empCodeStr || "0" }}
                </b-badge>

                <b-badge
                  v-if="reportDomain == 'myskoolhpgs'"
                  :variant="
                    data.item.empCode ? 'light-primary' : 'light-danger'
                  "
                  class="ml-50"
                >
                  EMP# {{ data.item.empCode }}
                </b-badge>

                <b-badge
                  v-if="['myskoolfgs','myskooldeenway'].includes(reportDomain)"
                  :variant="
                    data.item.empCodeStr ? 'light-primary' : 'light-primary'
                  "
                  class="ml-50"
                >
                  EMP# {{ data.item.empCodeStr || "0" }}
                </b-badge>
              </small>
              <b-link
                v-if="
                  (data.item.status || '').toLowerCase() == 'left' &&
                  data.item.leaving_date
                "
                class="font-weight-bold d-block text-nowrap mt-25"
              >
                <b-badge variant="light-primary">
                  {{
                    new Date(data.item.leaving_date).toLocaleDateString(
                      "en-UK",
                      {
                        year: "numeric",
                        day: "numeric",
                        month: "short",
                      }
                    )
                  }}
                </b-badge>
              </b-link>
              <b-link
                v-if="
                  (data.item.status || '').toLowerCase() == 'present' &&
                  data.item.appointedOn
                "
                class="font-weight-bold d-block text-nowrap mt-25"
              >
                <b-badge variant="light-primary">
                  <span
                    v-if="
                      reportDomain === 'myskoolstjacob' &&
                      data.item.rejoining_date
                    "
                  >
                    {{
                      new Date(data.item.rejoining_date).toLocaleDateString(
                        "en-UK",
                        {
                          year: "numeric",
                          day: "numeric",
                          month: "short",
                        }
                      )
                    }}
                  </span>
                  <span v-else>
                    {{
                      new Date(data.item.appointedOn).toLocaleDateString(
                        "en-UK",
                        {
                          year: "numeric",
                          day: "numeric",
                          month: "short",
                        }
                      )
                    }}
                  </span>
                </b-badge>
              </b-link>
            </b-media>
          </template>

          <template #cell(campus)="data">
            <b-badge variant="light-primary">
              {{ data.item.metaCampusName || getCampus(data.item.campusID) }}
            </b-badge>
          </template>
          <template #cell(contact_number)="data">
            <b-badge variant="light-primary">
              {{ data.item.contact_number }}
            </b-badge>
          </template>
          <template #cell(department)="data">
            <b-badge variant="light-primary">
              {{ getDepName(data.item.departmentID) }}
            </b-badge>
          </template>
          <template #cell(qualification)="data">
            <b-badge variant="light-primary">
              {{ data.item.qualification }}
            </b-badge>
          </template>
          <template #cell(experience)="data">
            <b-badge variant="light-primary">
              {{ data.item.experience }}
            </b-badge>
          </template>
          <template #cell(designation)="data">
            <b-badge variant="light-primary">
              {{ data.item.designation }}
            </b-badge>
          </template>
          <template #cell(totalSalary)="data">
            <b-badge variant="light-primary">
              {{ data.item.totalSalary }}
            </b-badge>
          </template>
          <template #cell(status)="data">
            <b-badge
              :variant="
                (data.item.status || '').toLowerCase() == 'left'
                  ? 'light-danger'
                  : 'light-primary'
              "
            >
              {{ data.item.status }}
            </b-badge>
          </template>

          <template #cell(rfID)="data">
            <b-badge variant="light-primary">
              {{ data.item.rfID }}
            </b-badge>
          </template>

          <template #cell(empCode)="data">
            <b-badge variant="light-primary">
              {{ data.item.empCode }}
            </b-badge>
          </template>

          <template #cell(father_name)="data">
            <b-badge variant="light-primary">
              {{ data.item.father_name }}
            </b-badge>
          </template>

          <template #cell(surname)="data">
            <b-badge variant="light-primary">
              {{ data.item.surname }}
            </b-badge>
          </template>

          <template #cell(leaving_date)="data">
            <b-badge variant="light-primary" v-if="data.item.leaving_date">
              {{
                new Date(data.item.leaving_date).toLocaleDateString("en-UK", {
                  year: "numeric",
                  day: "numeric",
                  month: "short",
                })
              }}
            </b-badge>
            <span v-else>-</span>
          </template>

          <template #cell(rejoining_date)="data">
            <b-badge variant="light-primary" v-if="data.item.rejoining_date">
              {{
                new Date(data.item.rejoining_date).toLocaleDateString("en-UK", {
                  year: "numeric",
                  day: "numeric",
                  month: "short",
                })
              }}
            </b-badge>
            <span v-else>-</span>
          </template>

          <template #cell(appointedOn)="data">
            <b-badge variant="light-primary" v-if="data.item.appointedOn">
              {{
                new Date(data.item.appointedOn).toLocaleDateString("en-UK", {
                  year: "numeric",
                  day: "numeric",
                  month: "short",
                })
              }}
            </b-badge>
            <span v-else>-</span>
          </template>

          <template #cell(basicSalary)="data">
            <b-badge variant="light-primary">
              {{ data.item.basicSalary || 0 }}
            </b-badge>
          </template>

          <template #cell(bonuses)="data">
            <b-badge variant="light-primary">
              {{ data.item.bonuses || 0 }}
            </b-badge>
          </template>

          <template #cell(note)="data">
            <b-badge variant="light-primary">
              {{ data.item.note || "-" }}
            </b-badge>
          </template>

          <template #cell(allowedLeaves)="data">
            <b-badge variant="light-primary">
              {{ data.item.allowedLeaves || 0 }}
            </b-badge>
          </template>

          <template #cell(joinsAt)="data">
            <b-badge variant="light-primary" v-if="data.item.joinsAt">
              {{
                new Date(data.item.joinsAt).toLocaleDateString("en-UK", {
                  year: "numeric",
                  day: "numeric",
                  month: "short",
                })
              }}
            </b-badge>
            <span v-else>-</span>
          </template>

          <template #cell(accountTitle)="data">
            <b-badge variant="light-primary">
              {{ data.item.accountTitle || "-" }}
            </b-badge>
          </template>

          <template #cell(accountNumber)="data">
            <b-badge variant="light-primary">
              {{ data.item.accountNumber || "-" }}
            </b-badge>
          </template>

          <template #cell(payMode)="data">
            <b-badge variant="light-primary">
              {{ data.item.payMode || "-" }}
            </b-badge>
          </template>

          <template #cell(cnic)="data">
            <b-badge variant="light-primary">
              {{ data.item.cnic || "-" }}
            </b-badge>
          </template>

          <template #cell(leaves_allowed_from)="data">
            <b-badge
              variant="light-primary"
              v-if="data.item.leaves_allowed_from"
            >
              {{
                new Date(data.item.leaves_allowed_from).toLocaleDateString(
                  "en-UK",
                  { year: "numeric", day: "numeric", month: "short" }
                )
              }}
            </b-badge>
            <span v-else>-</span>
          </template>

          <template #cell(gender)="data">
            <b-badge variant="light-primary">
              {{ data.item.gender || "-" }}
            </b-badge>
          </template>

          <template #cell(date_of_birth)="data">
            <b-badge variant="light-primary" v-if="data.item.date_of_birth">
              {{
                new Date(data.item.date_of_birth).toLocaleDateString("en-UK", {
                  year: "numeric",
                  day: "numeric",
                  month: "short",
                })
              }}
            </b-badge>
            <span v-else>-</span>
          </template>

          <template #cell(address_current)="data">
            <b-badge variant="light-primary">
              {{ data.item.address_current || "-" }}
            </b-badge>
          </template>

          <template #cell(address_permanent)="data">
            <b-badge variant="light-primary">
              {{ data.item.address_permanent || "-" }}
            </b-badge>
          </template>

          <template #cell(emergency_contact_person)="data">
            <b-badge variant="light-primary">
              {{ data.item.emergency_contact_person || "-" }}
            </b-badge>
          </template>

          <template #cell(emergency_contact_relation)="data">
            <b-badge variant="light-primary">
              {{ data.item.emergency_contact_relation || "-" }}
            </b-badge>
          </template>

          <template #cell(emergency_number)="data">
            <b-badge variant="light-primary">
              {{ data.item.emergency_number || "-" }}
            </b-badge>
          </template>

          <template #cell(deviceID)="data">
            <b-badge variant="light-primary">
              {{ data.item.deviceID || "-" }}
            </b-badge>
          </template>

          <template #cell(documents)="data">
            <b-badge variant="light-primary">
              {{ data.item.documents ? "Available" : "Not Available" }}
            </b-badge>
          </template>

          <template #cell(availibility)="data">
            <b-badge variant="light-primary">
              {{ data.item.availibility || "-" }}
            </b-badge>
          </template>

          <template #cell(expectedSalary)="data">
            <b-badge variant="light-primary">
              {{ data.item.expectedSalary || 0 }}
            </b-badge>
          </template>

          <template #cell(spouse)="data">
            <b-badge variant="light-primary">
              {{ data.item.spouse || "-" }}
            </b-badge>
          </template>

          <template #cell(isCoordinator)="data">
            <b-badge
              :variant="
                data.item.isCoordinator ? 'light-success' : 'light-secondary'
              "
            >
              {{ data.item.isCoordinator ? "Yes" : "No" }}
            </b-badge>
          </template>

          <template #cell(remaining_leaves)="data">
            <b-badge variant="light-primary">
              {{ data.item.remaining_leaves || 0 }}
            </b-badge>
          </template>

          <template #cell(card_number)="data">
            <b-badge variant="light-primary">
              {{ data.item.card_number || "-" }}
            </b-badge>
          </template>

          <template #cell(teachingLevel)="data">
            <b-badge variant="light-primary">
              {{ data.item.teachingLevel || "-" }}
            </b-badge>
          </template>

          <template #cell(applicantStatus)="data">
            <b-badge variant="light-primary">
              {{ data.item.applicantStatus || "-" }}
            </b-badge>
          </template>

          <template #cell(registrationDate)="data">
            <b-badge
              variant="light-primary"
              v-if="
                data.item.registrationDate &&
                data.item.registrationDate !== '0001-01-01T00:00:00'
              "
            >
              {{
                new Date(data.item.registrationDate).toLocaleDateString(
                  "en-UK",
                  { year: "numeric", day: "numeric", month: "short" }
                )
              }}
            </b-badge>
            <span v-else>-</span>
          </template>

          <template #cell(approvalDate)="data">
            <b-badge variant="light-primary" v-if="data.item.approvalDate">
              {{
                new Date(data.item.approvalDate).toLocaleDateString("en-UK", {
                  year: "numeric",
                  day: "numeric",
                  month: "short",
                })
              }}
            </b-badge>
            <span v-else>-</span>
          </template>

          <template #cell(demoCampusID)="data">
            <b-badge variant="light-primary">
              {{ data.item.demoCampusID || 0 }}
            </b-badge>
          </template>

          <template #cell(sharePerc)="data">
            <b-badge variant="light-primary">
              {{ data.item.sharePerc || 0 }}%
            </b-badge>
          </template>

          <template #cell(accountID)="data">
            <b-badge variant="light-primary">
              {{ data.item.accountID || 0 }}
            </b-badge>
          </template>

          <template #cell(branchID)="data">
            <b-badge variant="light-primary">
              {{ data.item.branchID || 0 }}
            </b-badge>
          </template>

          <template #cell(graceMins)="data">
            <b-badge variant="light-primary">
              {{ data.item.graceMins || 0 }} mins
            </b-badge>
          </template>

          <template #cell(partTimerDays)="data">
            <b-badge variant="light-primary">
              {{ data.item.partTimerDays || "-" }}
            </b-badge>
          </template>

          <template #cell(totalPeriods)="data">
            <b-badge variant="light-primary">
              {{ data.item.totalPeriods || 0 }}
            </b-badge>
          </template>

          <template #cell(canPostNewsFeed)="data">
            <b-badge
              :variant="
                data.item.canPostNewsFeed ? 'light-success' : 'light-secondary'
              "
            >
              {{ data.item.canPostNewsFeed ? "Yes" : "No" }}
            </b-badge>
          </template>

          <template #head(actions)="data">
            <div class="text-center">
              <span>{{ $t(data.label) }}</span>
            </div>
          </template>

          <template #cell(actions)="data">
            <div class="d-flex align-items-center">
              <b-button
                v-if="rights.edit"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                v-b-tooltip.hover.top
                :title="$t('View Details')"
                class="btn-icon mr-1"
                :to="{
                  name: 'staff-details',
                  params: {
                    id: data.item.id,
                  },
                }"
              >
                <feather-icon icon="EyeIcon" class="" />
              </b-button>
              <b-button
                v-if="rights.add || rights.edit"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                :variant="
                  data.item.synced ? 'outline-success' : 'outline-danger'
                "
                class="btn-icon mr-1"
                v-b-tooltip.hover.top
                :title="
                  data.item.synced
                    ? $t('Synced Account Details')
                    : $t('Not Synced')
                "
                @click="
                  data.item.synced
                    ? showSyncedDetails(data.item.syncedDetails, data.item.id)
                    : null
                "
              >
                <feather-icon icon="SmartphoneIcon" />
              </b-button>
              <b-button
                v-if="
                  $store.state.rights['manage-planner'] &&
                  (data.item.status || '').toLowerCase() == 'present'
                "
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                v-b-tooltip.hover.top
                :title="$t('Planner')"
                class="btn-icon mr-1"
                @click="openPlanner(data.item.id)"
              >
                <feather-icon icon="FileTextIcon" class="" />
              </b-button>

              <b-button
                v-if="
                  rights.edit &&
                  (data.item.status || '').toLowerCase() == 'present'
                "
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                v-b-tooltip.hover.top
                :title="$t('Timetable')"
                class="btn-icon mr-1"
                @click="timeTable(data.item.id)"
              >
                <feather-icon icon="ClipboardIcon" class="" />
              </b-button>

              <b-button
                v-if="rights.edit"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                v-b-tooltip.hover.top
                :title="$t('Edit')"
                class="btn-icon mr-1"
                :to="
                  (data.item.status || '').toLowerCase() == 'applicant'
                    ? {
                        name: 'staff-application',
                        params: {
                          id: data.item.id,
                        },
                      }
                    : {
                        name: rights.singlePage
                          ? 'manage-staff-accounts'
                          : 'manage-staff',
                        params: {
                          id: data.item.id,
                        },
                      }
                "
              >
                <!-- @click="Edit(data.item.id)" -->
                <feather-icon icon="EditIcon" class="" />
              </b-button>

              <!-- v-if="
                  rights.editCampus && (data.item.status || '').toLowerCase() == 'present'
                " -->
              <!-- <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon mr-1"
                v-b-tooltip.hover.top
                :title="$t('Transfer Staff')"
                @click="openCh(data.item)"
              >
                <feather-icon icon="HomeIcon" />
              </b-button>  -->

              <b-button
                v-if="
                  ctObj &&
                  ctObj.valueBool &&
                  (rights.view || rights.edit) &&
                  (data.item.status || '').toLowerCase() == 'present'
                "
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                v-b-tooltip.hover.top
                :title="$t('Teaching Classes')"
                class="btn-icon mr-1"
                @click="openClasses(data.item.id)"
              >
                <feather-icon icon="FileTextIcon" />
              </b-button>

              <b-button
                v-if="
                  slrObj &&
                  slrObj.valueBool &&
                  ['present'].includes((data.item.status || '').toLowerCase())
                "
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-success"
                class="btn-icon mr-1"
                v-b-tooltip.hover.top
                :title="$t('Request')"
                @click="openLeaveReq(data.item)"
              >
                <feather-icon icon="LogOutIcon" />
              </b-button>

              <b-button
                v-if="
                  !rights.hidePayroll &&
                  rights.edit &&
                  (data.item.status || '').toLowerCase() == 'present'
                "
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-danger"
                v-b-tooltip.hover.top
                :title="$t('Left')"
                class="btn-icon mr-1"
                @click="openLeft(data.item)"
              >
                <!-- @click="changeStatus(data.item, 'left')" -->
                <feather-icon icon="XIcon" />
              </b-button>
              <b-button
                v-else-if="
                  !rights.hidePayroll &&
                  rights.edit &&
                  (data.item.status || '').toLowerCase() == 'left'
                "
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-danger"
                v-b-tooltip.hover.top
                :title="$t('Readmit')"
                class="btn-icon mr-1"
                @click="openReadmit(data.item)"
              >
                <!-- @click="changeStatus(data.item, 'present')" -->
                <feather-icon icon="CheckIcon" />
              </b-button>
              <b-button
                v-if="rights.delete"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-danger"
                v-b-tooltip.hover.top
                :title="$t('Delete')"
                class="btn-icon"
                @click="Delete(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
              <!-- <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon mr-1"
                @click="Perf(data.item.id)"
              >
                <feather-icon icon="StarIcon" />
              </b-button> -->

              <b-button
                v-if="showFaceId"
                variant="primary"
                class="btn-icon mr-1 ml-1"
                v-b-tooltip.hover.top
                :title="$t('Register Face ID')"
                :disabled="faceIdLoading"
                @click="registerFaceId(data.item)"
              >
                <b-spinner v-if="faceIdLoading" small />
                <feather-icon v-else icon="UserIcon" />
              </b-button>
            </div>
          </template>
        </b-table>

        <b-row>
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >{{ $t("Showing") }} {{ items.length }} {{ $t("of") }}
              {{ totalCount == 0 ? items.length : totalCount }}
              {{ $t("entries") }}</span
            >
          </b-col>
          <b-col cols="12" md="12">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalCount"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-50 justify-content-center"
              prev-class="prev-item"
              next-class="next-item"
              @input="LoadData()"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <!-- Add inside b-card after the table -->
    <b-modal
      v-model="showFaceIdModal"
      :title="$t('Register Face ID')"
      size="lg"
      centered
      hide-footer
    >
      <iframe
        :src="enrollmentLink"
        style="width: 100%; height: 70vh; border: none"
        allow="camera;microphone"
        referrerpolicy="no-referrer"
      ></iframe>

      <b-row class="mt-2 bg-white p-2">
        <b-col class="d-flex justify-content-center">
          <!-- Removed copy link button -->
          <b-button variant="success" @click="shareWhatsApp">
            <feather-icon icon="MessageSquareIcon" class="mr-50" />
            <span>{{ $t("WhatsApp Link") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <!-- Column Settings Sidebar -->
    <b-sidebar
      id="sidebar-settings"
      ref="settingsSidebar"
      bg-variant="white"
      v-model="visibilitySettings"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
      @hidden="setFocus()"
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Column Settings") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibilitySettings = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <!-- Action Buttons at Top -->
        <b-row class="mb-3">
          <b-col cols="12">
            <div class="d-flex justify-content-between align-items-center">
              <b-button
                @click="resetToDefault"
                variant="outline-secondary"
                size="sm"
              >
                {{ $t("Reset to Default") }}
              </b-button>
              <b-button @click="selectAll" variant="outline-primary" size="sm">
                {{ $t("Select All") }}
              </b-button>
              <b-button
                @click="saveColumnSettings"
                variant="success"
                size="sm"
                :disabled="savingSettings"
              >
                <b-spinner v-if="savingSettings" small class="mr-25" />
                {{ $t("Save Settings") }}
              </b-button>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <h6 class="mb-2">{{ $t("Select columns to display") }}:</h6>
            <div v-for="field in allFields" :key="field.key" class="mb-2">
              <b-form-checkbox
                v-model="field.visible"
                :disabled="field.required"
              >
                {{ $t(field.label) }}
                <small v-if="field.required" class="text-muted"
                  >({{ $t("Required") }})</small
                >
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <!-- Designation Settings Sidebar -->
    <b-sidebar
      id="sidebar-designation-settings"
      ref="designationSidebar"
      bg-variant="white"
      v-model="visibilityDesignation"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
      lazy
      @hidden="onDesignationSidebarHidden"
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Designation Settings") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibilityDesignation = false"
        />
      </div>

      <div class="px-2 py-2 border-bottom">
        <b-button
          @click="saveDesignationSettings()"
          variant="primary"
          block
          :disabled="
            savingDesignation ||
            loadingDesignationSettings ||
            editingDesignationIndex > -1
          "
        >
          <b-spinner v-if="savingDesignation" small class="mr-25" />
          <feather-icon v-else icon="SaveIcon" class="mr-25" />
          {{ $t("Save Designations") }}
        </b-button>
        <small
          v-if="editingDesignationIndex > -1"
          class="text-warning d-block text-center mt-50"
        >
          {{ $t("Finish or cancel edit before saving") }}
        </small>
      </div>

      <div class="p-2">
        <div
          v-if="loadingDesignationSettings"
          class="text-center text-muted py-2"
        >
          <b-spinner small class="mr-50" />
          {{ $t("Loading") }}...
        </div>

        <template v-else>
          <b-form-group :label="$t('Department')" class="mb-1">
            <v-select
              v-model="newDesignationDepartmentID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="departments"
              label="name"
              :reduce="(val) => Number(val.id)"
              :clearable="false"
              :searchable="true"
              :placeholder="$t('Select department')"
              class="designation-dept-select"
            />
          </b-form-group>

          <b-form-group
            :label="
              editingDesignationIndex > -1
                ? $t('Edit Designation')
                : $t('Add New Designation')
            "
            class="mb-2"
          >
            <b-form-input
              v-model="newDesignation"
              :placeholder="$t('Enter designation name')"
              class="mb-1"
              @keyup.enter="submitDesignationForm()"
            />

            <!-- Add mode -->
            <b-button
              v-if="editingDesignationIndex < 0"
              @click="submitDesignationForm()"
              variant="primary"
              block
              :disabled="!newDesignation.trim() || !newDesignationDepartmentID"
            >
              <feather-icon icon="PlusIcon" size="14" class="mr-50" />
              {{ $t("Add Designation") }}
            </b-button>

            <!-- Edit mode: clear Update / Cancel -->
            <div v-else class="d-flex">
              <b-button
                @click="cancelEditDesignation()"
                variant="outline-secondary"
                class="flex-fill mr-50"
              >
                <feather-icon icon="XIcon" size="14" class="mr-50" />
                {{ $t("Cancel") }}
              </b-button>
              <b-button
                @click="submitDesignationForm()"
                variant="success"
                class="flex-fill"
                :disabled="!newDesignation.trim() || !newDesignationDepartmentID"
              >
                <feather-icon icon="CheckIcon" size="14" class="mr-50" />
                {{ $t("Update") }}
              </b-button>
            </div>

            <small
              v-if="editingDesignationIndex > -1"
              class="text-primary d-block mt-50"
            >
              {{ $t("Editing selected designation") }}
            </small>
          </b-form-group>

          <div class="d-flex justify-content-between align-items-center mb-1">
            <h6 class="mb-0">{{ $t("Current Designations") }}</h6>
            <small class="text-muted">{{ designations.length }}</small>
          </div>

          <div v-if="designations.length === 0" class="text-muted small">
            {{ $t("No designations added yet.") }}
          </div>

          <div v-else class="designation-list">
            <div
              v-for="(designation, index) in designations"
              :key="'desig-' + index + '-' + designation.name"
              class="d-flex align-items-center justify-content-between border rounded px-1 py-50 mb-50 designation-row"
              :class="{
                'border-primary bg-light-primary':
                  editingDesignationIndex === index,
              }"
            >
              <div class="pr-1" style="min-width: 0; flex: 1">
                <div class="font-weight-bold text-truncate">
                  {{ designation.name }}
                </div>
                <span
                  class="badge badge-pill mt-25"
                  :class="
                    getDepName(designation.departmentID)
                      ? 'badge-light-primary'
                      : 'badge-light-warning'
                  "
                >
                  {{
                    getDepName(designation.departmentID) || $t("No Department")
                  }}
                </span>
              </div>
              <div class="d-flex align-items-center flex-shrink-0">
                <b-button
                  size="sm"
                  variant="flat-primary"
                  class="btn-icon"
                  :disabled="savingDesignation"
                  v-b-tooltip.hover.top
                  :title="$t('Edit')"
                  @click="startEditDesignation(index)"
                >
                  <feather-icon icon="Edit2Icon" size="14" />
                </b-button>
                <b-button
                  size="sm"
                  variant="flat-danger"
                  class="btn-icon"
                  :disabled="savingDesignation"
                  v-b-tooltip.hover.top
                  :title="$t('Delete')"
                  @click="removeDesignation(index)"
                >
                  <feather-icon icon="Trash2Icon" size="14" />
                </b-button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </b-sidebar>

    <!-- Select Template Modal -->
    <b-modal
      id="modal-select-template"
      v-model="showTemplateModal"
      :title="$t('Select Template')"
      centered
      size="lg"
      hide-footer
    >
      <div class="p-1">
        <b-row class="mb-2">
          <b-col md="12">
            <b-input-group>
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input
                v-model="templateSearch"
                :placeholder="$t('Search templates') + '...'"
                @input="fetchTemplates()"
              />
            </b-input-group>
          </b-col>
        </b-row>

        <b-table
          :items="templates"
          :fields="templateFields"
          :busy="templateLoading"
          hover
          show-empty
          responsive
          selectable
          select-mode="single"
          @row-selected="(row) => (selectedTemplate = row[0])"
          class="mb-2"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-1">{{ $t("Loading templates") }}...</strong>
            </div>
          </template>

          <template #head()="scope">
            <div>
              <span>{{ $t(scope.label) }}</span>
            </div>
          </template>

          <template #cell(title)="data">
            <span class="font-weight-bold">{{ data.value }}</span>
          </template>

          <template #cell(templateFor)="data">
            <b-badge variant="light-primary">{{ data.value }}</b-badge>
          </template>
        </b-table>

        <b-pagination
          v-if="templateTotal > templatePerPage"
          v-model="templatePage"
          :total-rows="templateTotal"
          :per-page="templatePerPage"
          align="center"
          size="sm"
          @input="fetchTemplates()"
        />

        <div class="d-flex justify-content-end mt-2">
          <b-button
            variant="outline-secondary"
            @click="showTemplateModal = false"
            class="mr-1"
          >
            {{ $t("Cancel") }}
          </b-button>
          <b-button
            variant="success"
            :disabled="!selectedTemplate || persistentSelectedIds.length === 0"
            @click="printWithTemplate()"
          >
            <b-spinner v-if="printingTemplate" small class="mr-50" />
            <feather-icon v-else icon="PrinterIcon" class="mr-50" />
            <span>{{ $t("Print") }}</span>
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Synced Details Modal -->
    <b-modal
      id="modal-synced-details"
      v-model="showSyncedModal"
      :title="$t('App Account Details')"
      centered
      hide-footer
    >
      <div v-if="selectedSyncedDetails" class="p-1">
        <b-row class="mb-1">
          <b-col cols="4" class="font-weight-bold d-flex align-items-center"
            >{{ $t("Username") }}:</b-col
          >
          <b-col
            cols="8"
            class="d-flex align-items-center justify-content-between"
          >
            <span>{{ selectedSyncedDetails.username }}</span>
            <b-button
              v-if="rights.delete"
              variant="outline-danger"
              class="btn-icon"
              size="sm"
              v-b-tooltip.hover.top
              :title="$t('Delete Sync Credential')"
              @click="deleteSyncedCredential()"
            >
              <feather-icon icon="Trash2Icon" size="14" />
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4" class="font-weight-bold">{{ $t("Status") }}:</b-col>
          <b-col cols="8" class="text-capitalize">
            <b-badge
              :variant="
                selectedSyncedDetails.status === 'active'
                  ? 'light-success'
                  : 'light-danger'
              "
            >
              {{ selectedSyncedDetails.status }}
            </b-badge>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <!-- Bulk increment -->
    <b-modal
      id="modal-bulk-increment"
      v-model="showBulkIncrementModal"
      :title="
        bulkIncStep === 'summary'
          ? $t('Increment summary')
          : $t('Bulk Increment')
      "
      centered
      size="lg"
      hide-footer
      no-close-on-backdrop
      :modal-class="
        bulkIncStep === 'summary'
          ? 'bulk-inc-modal bulk-inc-modal--summary-compact'
          : 'bulk-inc-modal bulk-inc-modal--import'
      "
      @hidden="resetBulkIncrementModal()"
    >
      <div v-if="bulkIncStep === 'form'">
        <b-form @submit.prevent="confirmBulkIncrement()">
          <b-form-group :label="$t('Department')">
            <v-select
              v-model="bulkIncObj.depList"
              multiple
              :closeOnSelect="false"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="[
                { name: $t('All Departments'), id: 0 },
                ...departments,
              ]"
              :clearable="false"
              label="name"
              :reduce="(val) => val.id"
              :placeholder="$t('Select department')"
              @input="setBulkIncDep()"
            />
          </b-form-group>
          <b-form-group :label="$t('Type')">
            <v-select
              v-model="bulkIncObj.type"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="bulkIncTypeOptions"
              :reduce="(opt) => opt.value"
              label="text"
              :clearable="false"
            />
          </b-form-group>
          <b-form-group :label="bulkIncValueLabel">
            <b-form-input
              v-model.number="bulkIncObj.value"
              type="number"
              min="0"
              step="any"
              :placeholder="bulkIncValuePlaceholder"
            />
          </b-form-group>
          <b-form-group :label="$t('Date')">
            <flat-pickr
              v-model="bulkIncObj.date"
              class="form-control"
              :config="config"
              :placeholder="$t('Select Date')"
            />
          </b-form-group>
          <b-form-group :label="$t('Note')">
            <b-form-textarea
              v-model.trim="bulkIncObj.note"
              rows="2"
              :placeholder="$t('Optional note')"
            />
          </b-form-group>
          <p class="text-muted small mb-0">
            {{
              bulkIncObj.type === "percentage"
                ? $t("Adds the given percentage of each staff member's basic salary.")
                : bulkIncObj.type === "amount"
                ? $t("Adds a fixed amount to each staff member's basic salary.")
                : $t("Sets each staff member's basic salary to the given value.")
            }}
          </p>
          <div class="d-flex justify-content-end mt-2">
            <b-button
              variant="outline-secondary"
              class="mr-1"
              @click="showBulkIncrementModal = false"
            >
              {{ $t("Cancel") }}
            </b-button>
            <b-button
              type="submit"
              variant="primary"
              :disabled="bulkIncrementSubmitting"
            >
              <b-spinner v-if="bulkIncrementSubmitting" small class="mr-50" />
              {{ $t("Update") }}
            </b-button>
          </div>
        </b-form>
      </div>
      <div v-else class="bulk-inc-summary bulk-inc-summary--compact">
        <div class="import-parse-stats mb-2">
          <div class="import-parse-stat import-parse-stat--ready">
            <span class="import-parse-stat__num">{{
              bulkIncResult.updatedCount || 0
            }}</span>
            <span class="import-parse-stat__lbl">{{ $t("Updated") }}</span>
          </div>
          <div class="import-parse-stat import-parse-stat--skip">
            <span class="import-parse-stat__num">{{
              bulkIncResult.skippedCount || 0
            }}</span>
            <span class="import-parse-stat__lbl">{{ $t("Skipped") }}</span>
          </div>
          <div class="import-parse-stat import-parse-stat--inc">
            <span class="import-parse-stat__num text-success"
              >+{{ formatMoney(bulkIncResult.totalIncrement) }}</span
            >
            <span class="import-parse-stat__lbl">{{
              $t("Total increment")
            }}</span>
          </div>
        </div>

        <div class="summary-total-inline mb-2">
          <span class="summary-total-inline__label">{{
            $t("Basic salary")
          }}</span>
          <span class="summary-total-inline__val">{{
            formatMoney(bulkIncResult.previousBasicSum)
          }}</span>
          <feather-icon
            icon="ArrowRightIcon"
            size="16"
            class="summary-total-inline__arrow"
          />
          <span class="summary-total-inline__val summary-total-inline__val--new">{{
            formatMoney(bulkIncResult.newBasicSum)
          }}</span>
          <b-badge variant="light-success" class="ml-1"
            >+{{ formatMoney(bulkIncResult.totalIncrement) }}</b-badge
          >
        </div>

        <div class="summary-table-wrap import-preview-table mb-2">
          <b-table
            :items="bulkIncResult.summary || []"
            :fields="incrementSummaryFields"
            small
            responsive
            sticky-header="240px"
            show-empty
            :empty-text="$t('No records')"
            class="bulk-inc-summary-table bulk-inc-preview-table mb-0"
          >
            <template #head()="scope">
              <span>{{ $t(scope.label) }}</span>
            </template>
            <template #cell(name)="data">
              <span class="font-weight-bold">{{ data.value }}</span>
            </template>
            <template #cell(departmentName)="data">
              <span class="text-muted">{{ data.value || "—" }}</span>
            </template>
            <template #cell(previousBasic)="data">
              {{ formatMoney(data.value) }}
            </template>
            <template #cell(newBasic)="data">
              <span class="text-primary font-weight-bold">{{
                formatMoney(data.value)
              }}</span>
            </template>
            <template #cell(incrementAmount)="data">
              <span class="text-success font-weight-bold"
                >+{{ formatMoney(data.value) }}</span
              >
            </template>
          </b-table>
        </div>

        <div class="d-flex justify-content-end">
          <b-button size="sm" variant="primary" @click="closeBulkIncrementSummary()">
            {{ $t("Close") }}
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Bulk increment import -->
    <b-modal
      id="modal-bulk-import-increment"
      v-model="showBulkImportIncrementModal"
      :title="
        importIncStep === 'summary'
          ? $t('Import summary')
          : $t('Import Increment')
      "
      centered
      size="lg"
      hide-footer
      no-close-on-backdrop
      :modal-class="
        importIncStep === 'summary'
          ? 'bulk-inc-modal bulk-inc-modal--summary-compact'
          : 'bulk-inc-modal bulk-inc-modal--import'
      "
      @hidden="resetBulkImportIncrementModal()"
    >
      <div v-if="importIncStep === 'form'" class="bulk-inc-import-form">
        <b-form-group :label="$t('Date')">
          <flat-pickr
            v-model="importIncObj.date"
            class="form-control"
            :config="config"
            :placeholder="$t('Select Date')"
          />
          <small class="text-muted">
            {{ $t("Applied to all rows in this import") }}
          </small>
        </b-form-group>
        <b-row class="mb-2">
          <b-col md="6" sm="12" class="mb-1">
            <b-button
              variant="outline-primary"
              block
              :disabled="exportIncrementTemplateLoading"
              @click="exportIncrementTemplate()"
            >
              <b-spinner
                v-if="exportIncrementTemplateLoading"
                small
                class="mr-50"
              />
              <feather-icon v-else icon="DownloadIcon" class="mr-50" />
              {{ $t("Export staff template") }}
            </b-button>
          </b-col>
          <b-col md="6" sm="12" class="mb-1">
            <b-button
              variant="primary"
              block
              :disabled="importIncrementParsing || importIncrementSubmitting"
              @click="$refs.importIncrementFile.click()"
            >
              <input
                ref="importIncrementFile"
                type="file"
                hidden
                accept=".xlsx,.xls,.csv"
                @change="onIncrementImportFileSelected"
              />
              <b-spinner
                v-if="importIncrementParsing"
                small
                class="mr-50"
              />
              <feather-icon v-else icon="UploadIcon" class="mr-50" />
              {{
                importIncrementParsing
                  ? $t("Reading file...")
                  : $t("Import file")
              }}
            </b-button>
          </b-col>
        </b-row>
        <b-form-group :label="$t('Note')">
          <b-form-textarea
            v-model.trim="importIncObj.note"
            rows="2"
            :placeholder="$t('Optional note')"
          />
        </b-form-group>
        <div
          v-if="
            importIncrementParseStats.included ||
            importIncrementParseStats.excludedNoAmount
          "
          class="import-parse-stats mb-2"
        >
          <div class="import-parse-stat import-parse-stat--ready">
            <span class="import-parse-stat__num">{{
              importIncrementParseStats.included
            }}</span>
            <span class="import-parse-stat__lbl">{{
              $t("Ready to import")
            }}</span>
          </div>
          <div
            v-if="importIncrementParseStats.excludedNoAmount"
            class="import-parse-stat import-parse-stat--skip"
          >
            <span class="import-parse-stat__num">{{
              importIncrementParseStats.excludedNoAmount
            }}</span>
            <span class="import-parse-stat__lbl">{{
              $t("Excluded (no amount)")
            }}</span>
          </div>
        </div>
        <div
          v-if="importIncrementPreview.length"
          class="summary-table-wrap import-preview-table mb-2"
        >
          <div class="import-preview-table__title text-muted small mb-50">
            {{ $t("Preview") }}
            <span class="font-weight-bold text-body">{{
              importIncrementRows.length
            }}</span>
            {{ $t("rows") }}
          </div>
          <b-table
            :items="importIncrementPreview"
            :fields="importIncrementPreviewFields"
            small
            responsive
            sticky-header="200px"
            show-empty
            class="bulk-inc-summary-table bulk-inc-preview-table mb-0"
          >
            <template #head()="scope">
              <span>{{ $t(scope.label) }}</span>
            </template>
            <template #cell(amount)="data">
              <span class="font-weight-bold text-right d-block">{{
                formatMoney(data.value)
              }}</span>
            </template>
          </b-table>
        </div>
        <div class="d-flex justify-content-end mt-2">
          <b-button
            variant="outline-secondary"
            class="mr-1"
            @click="showBulkImportIncrementModal = false"
          >
            {{ $t("Cancel") }}
          </b-button>
          <b-button
            variant="primary"
            :disabled="
              importIncrementSubmitting || importIncrementRows.length === 0
            "
            @click="submitImportIncrement()"
          >
            <b-spinner v-if="importIncrementSubmitting" small class="mr-50" />
            {{
              importIncrementSubmitting
                ? $t("Submitting...")
                : $t("Submit import")
            }}
          </b-button>
        </div>
      </div>
      <div v-else class="bulk-inc-summary bulk-inc-summary--compact">
        <div class="import-parse-stats mb-2">
          <div class="import-parse-stat import-parse-stat--ready">
            <span class="import-parse-stat__num">{{
              importIncResult.updatedCount || 0
            }}</span>
            <span class="import-parse-stat__lbl">{{ $t("Updated") }}</span>
          </div>
          <div class="import-parse-stat import-parse-stat--skip">
            <span class="import-parse-stat__num">{{
              importIncResult.skippedCount || 0
            }}</span>
            <span class="import-parse-stat__lbl">{{ $t("Skipped") }}</span>
          </div>
          <div class="import-parse-stat import-parse-stat--inc">
            <span class="import-parse-stat__num text-success"
              >+{{ formatMoney(importIncResult.totalIncrement) }}</span
            >
            <span class="import-parse-stat__lbl">{{
              $t("Total increment")
            }}</span>
          </div>
          <div
            v-if="importIncFileExcludedNoAmount"
            class="import-parse-stat import-parse-stat--file-skip"
          >
            <span class="import-parse-stat__num">{{
              importIncFileExcludedNoAmount
            }}</span>
            <span class="import-parse-stat__lbl">{{
              $t("Excluded (no amount)")
            }}</span>
          </div>
        </div>

        <div class="summary-total-inline mb-2">
          <span class="summary-total-inline__label">{{
            $t("Basic salary")
          }}</span>
          <span class="summary-total-inline__val">{{
            formatMoney(importIncResult.previousBasicSum)
          }}</span>
          <feather-icon
            icon="ArrowRightIcon"
            size="16"
            class="summary-total-inline__arrow"
          />
          <span class="summary-total-inline__val summary-total-inline__val--new">{{
            formatMoney(importIncResult.newBasicSum)
          }}</span>
          <b-badge variant="light-success" class="ml-1"
            >+{{ formatMoney(importIncResult.totalIncrement) }}</b-badge
          >
        </div>

        <div class="summary-table-wrap import-preview-table mb-2">
          <b-table
            :items="importIncResult.summary || []"
            :fields="importIncrementSummaryFields"
            small
            responsive
            sticky-header="240px"
            show-empty
            :empty-text="$t('No records')"
            class="bulk-inc-summary-table bulk-inc-preview-table mb-0"
          >
            <template #head()="scope">
              <span>{{ $t(scope.label) }}</span>
            </template>
            <template #cell(name)="data">
              <span class="font-weight-bold">{{ data.value }}</span>
            </template>
            <template #cell(departmentName)="data">
              <span class="text-muted">{{ data.value || "—" }}</span>
            </template>
            <template #cell(date)="data">
              {{ formatIncrementSummaryDate(data.value) }}
            </template>
            <template #cell(previousBasic)="data">
              {{ formatMoney(data.value) }}
            </template>
            <template #cell(newBasic)="data">
              <span class="text-primary font-weight-bold">{{
                formatMoney(data.value)
              }}</span>
            </template>
            <template #cell(incrementAmount)="data">
              <span class="text-success font-weight-bold"
                >+{{ formatMoney(data.value) }}</span
              >
            </template>
          </b-table>
        </div>

        <div class="d-flex justify-content-end">
          <b-button size="sm" variant="primary" @click="closeImportIncrementSummary()">
            {{ $t("Close") }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BDropdownHeader,
  BPagination,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BContainer,
  BMediaAside,
  BSpinner,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BInputGroup,
  BInputGroupAppend,
  BFormTextarea,
  BToast,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { mapActions, mapGetters } from "vuex";
import {
  getUploadedPaths,
  uploadToMySkool,
  getMediaPreviewUrl,
  handleDrivePreviewError,
  isImageUrl,
} from "@/utils/gdriveUpload";
import readXlsxFile from "read-excel-file";

import {
  buildFormattedWorksheet,
  writeWorkbookToFile,
  STAFF_EXPORT_COLUMNS,
  STAFF_INCREMENT_IMPORT_COLUMNS,
} from "@/utils/excelExport";

import RequestDetails from "./RequestDetails.vue";
import Vue from "vue";

import axios from "axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { openKentStaffDocumentRoute, isCampusBrandedStaffIdCardDomain } from "@/views/myskool/reports/kentStaffPrintUtils";

// Register the toast component
Vue.component("b-toast", BToast);

export default {
  components: {
    BInputGroup,
    BCard,
    BRow,
    BBadge,
    BTable,
    BCol,
    BAvatar,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BSpinner,
    BFormCheckbox,
    BForm,
    BContainer,
    BMediaAside,
    BImg,
    BMedia,
    BLink,
    BDropdown,
    BDropdownItem,
    BDropdownHeader,
    BPagination,
    BFormTextarea,
    vSelect,
    flatPickr,
    RequestDetails,
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  async created() {
    let right = {};
    this.$store.state.menu.forEach((el) => {
      el.children.forEach((ch) => {
        right[ch.route] = {
          view: ch.view,
          add: ch.add,
          edit: ch.edit,
          delete: ch.delete,
          editCampus: ch.editCampus,
          disableImport: ch.disableImport,
          disableExport: ch.disableExport,
          hidePayroll: ch.hidePayroll,
          bulkIncrement: ch.bulkIncrement,
          hideDocuments: ch.hideDocuments,
          singlePage: ch.singlePage,
        };
      });
    });
    // console.log(right);
    this.$store.commit("setRights", right);

    if (!this.$store.state.rights[this.$route.name]) {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];

      let obj = this.filterData.find(
        (el) =>
          el.db == this.$store.state.userData.db &&
          el.cID == this.$store.state.userData.cId
      );
      // console.log(obj);
      if (obj) {
        this.filter.dep = obj.depID;
        this.filter.cID = obj.campID
          ? obj.campID
          : this.$store.state.userData.cId;
        this.totalCount = obj.total;
        this.currentPage = obj.page;
        this.currentStatus = obj.currentStatus || "present";
        this.filter.status = this.currentStatus;
        await this.LoadData();
      } else {
        await this.LoadData();
      }

      // this.LoadData();
      this.LoadDep();
      this.loadSettings();
      this.loadColumnSettings(); // Load saved column settings on component creation
      this.loadDesignationSettings(); // Load saved designation settings on component creation
      this.loadSearchCriteriaFromStorage(); // Load saved search criteria from localStorage
      this.LoadSettingsAll();
      if (this.reportDomain == "myskoolhpgs") {
        this.fields.splice(2, 0, { label: "campus", key: "campus" });
        this.fields2.splice(2, 0, { label: "campus", key: "campus" });
        // Update allFields to show campus for this domain
        const campusField = this.allFields.find((f) => f.key === "campus");
        if (campusField) campusField.visible = true;
        this.LoadCampuses();
      }
      if (this.reportDomain == "myskoolskh") {
        this.LoadSessions();
      }
      this.setFocus();
    }
  },
  computed: {
    isIussDomain() {
      return this.reportDomain === "myskooliuss";
    },
    usesCampusBrandedStaffIdCardPrint() {
      return isCampusBrandedStaffIdCardDomain(this.reportDomain);
    },
    kentStaffPrintOptionsForGrid() {
      if (this.reportDomain === "myskoolspell") {
        return [{ name: "ID Card", value: "id-card" }];
      }
      return this.kentStaffPrintOptions;
    },
    usesStructuredLeavingReasons() {
      return (
        this.reportDomain === "myskooliuss" || this.reportDomain === "myskool"
      );
    },
    leavingCategoryOptions() {
      if (!this.usesStructuredLeavingReasons) return this.requestOptions;
      return Object.keys(this.iussLeavingReasonsByCategory).map((category) => ({
        text: category,
        value: category,
      }));
    },
    leavingReasonOptions() {
      if (!this.usesStructuredLeavingReasons) return [];
      const reasons =
        this.iussLeavingReasonsByCategory[this.myObj.leavingCategory] || [];
      return reasons.map((reason) => ({ text: reason, value: reason }));
    },
    isOtherLeavingReason() {
      return (
        this.usesStructuredLeavingReasons &&
        String(this.myObj.leavingReason || "")
          .toLowerCase()
          .includes("other (specify)")
      );
    },
    showBulkIncrement() {
      if (this.rights?.hidePayroll) return false;
      return this.rights?.bulkIncrement === true;
    },

    filters: function () {
      return this.items.filter((pro) => {
        return (
          pro.name.toLowerCase().match(this.searchQuery.toLowerCase()) ||
          pro.id == this.searchQuery
        );
      });
    },

    designationOptionsForFilter() {
      return this.getDesignationNamesForDepartment(this.filter.dep);
    },

    campDesignationOptions() {
      return this.getDesignationNamesForDepartment(
        this.campObj && this.campObj.departmentID
      );
    },

    displayFields() {
      let visibleFields = this.allFields
        .filter((field) => field.visible)
        .map((field) => {
          let fieldConfig = {
            label: field.label,
            key: field.key,
            stickyColumn: field.key === "name",
            tdClass: field.key === "name" ? "bg-white" : undefined,
            thStyle:
              field.key === "name"
                ? "min-width: 300px; width: 300px;"
                : undefined,
            tdStyle:
              field.key === "name"
                ? "min-width: 300px; width: 300px;"
                : undefined,
            sortable: false, // Disable default sorting for all columns
          };

          // Add sorting functionality only for specific columns
          if (
            field.key === "name" ||
            field.key === "designation" ||
            field.key === "department" ||
            field.key === "doa"
          ) {
            fieldConfig.sortable = true;
            // Add arrow only if this column is currently being sorted
            if (this.sortBy === field.key) {
              const arrow = this.sortOrder === "asc" ? "" : "";
              fieldConfig.label = field.label + arrow;
            }
          }

          return fieldConfig;
        });

      // Handle salary visibility logic
      if (this.showSalary && this.showSalary.valueBool) {
        // Make sure totalSalary is visible when salary should be shown
        const totalSalaryField = this.allFields.find(
          (f) => f.key === "totalSalary"
        );
        if (
          totalSalaryField &&
          !visibleFields.find((f) => f.key === "totalSalary")
        ) {
          visibleFields.push({
            label: totalSalaryField.label,
            key: totalSalaryField.key,
            sortable: false,
          });
        }
      }

      // Auto-show Leaving Date column when filtering by "left" status
      if (
        (this.currentStatus || "").toLowerCase() === "left" &&
        !visibleFields.find((f) => f.key === "leaving_date")
      ) {
        const leavingField = {
          label: "Leaving Date",
          key: "leaving_date",
          sortable: false,
        };
        // Insert right after the status column if present, otherwise before actions
        const statusIdx = visibleFields.findIndex((f) => f.key === "status");
        if (statusIdx !== -1) {
          visibleFields.splice(statusIdx + 1, 0, leavingField);
        } else {
          visibleFields.push(leavingField);
        }
      }

      // Always include actions at the end
      visibleFields.push("actions");

      return visibleFields;
    },

    bulkIncValueLabel() {
      if (this.bulkIncObj.type === "percentage") return this.$t("Percentage");
      if (this.bulkIncObj.type === "direct") return this.$t("New basic salary");
      return this.$t("Amount");
    },

    bulkIncValuePlaceholder() {
      if (this.bulkIncObj.type === "percentage") return "10";
      return "0";
    },
  },
  data() {
    return {
      rights: {},
      exporting: false,
      updatingPolicy: false,
      filterloading: false,
      filter: {
        cID: this.$store.state.userData.cId,
        dep: 0,
        status: "present",
        appointedFrom: "",
        appointedTo: "",
        leavingFrom: "",
        leavingTo: "",
        designation: "",
        gender: "",
      },
      genderFilterOptions: [
        { text: "All", value: "" },
        { text: "Male", value: "Male" },
        { text: "Female", value: "Female" },
      ],
      // Sorting state
      sortBy: (() => {
        const domain = this.$store.state.report.replace(/_/g, "");
        console.log("Report Domain:", domain);
        const sortBy =
          domain === "myskoolstjacob" || domain === "jacoc" ? "doa" : "name";
        console.log("Sort By:", sortBy);
        return sortBy;
      })(),
      sortOrder: "asc",
      classes: [],
      contacterror: false,
      mydocloading: false,
      docsloading: "Upload",
      docLoading: false,
      docList: [],
      request: false,
      sidebarTitle: "Request",
      sidebarButton: "Save",
      buttonIcon: "PlusIcon",
      dataLoading: false,
      departments: [],
      visibility: false,
      logoloading: "",
      searchQuery: "",
      // Search criteria functionality
      searchCriteriaOptions: [
        { text: "General", value: "", description: "Current login" },
        { text: "ID", value: "id", description: "Search by staff ID" },
        { text: "Name", value: "name", description: "Search by name" },
        {
          text: "Father Name",
          value: "fatherName",
          description: "Search by father name",
        },
        {
          text: "Contact",
          value: "contact",
          description: "Search by contact number",
        },
        { text: "RFID", value: "rfid", description: "Search by RFID" },
      ],
      selectedSearchCriteria: {
        text: "General",
        value: "",
        description: "Current login",
      },
      currentPage: 1,
      perPage: 50,
      totalCount: 0,
      errors: {
        status: false,
      },
      statusOptions: [
        { text: "All", value: "all" },
        { text: "Working", value: "present" },
        { text: "Left", value: "left" },
        { text: "Applicant", value: "applicant" },
      ],
      FilterStOptions: [
        { text: "All", value: "all" },
        { text: "Working", value: "present" },
        { text: "Left", value: "left" },
        { text: "Applicant", value: "applicant" },
      ],
      currentStatus: "present",
      filterData: this.$store.state.staffFilter,
      date: {
        range: "",
      },
      index: null,
      cover: "",
      docs: [],
      partners: [],
      fields: [
        { label: "S.No", key: "index" },
        { label: "name", key: "name", stickyColumn: true, tdClass: "bg-white" },
        // { label: "father name", key: "father_name" },
        { label: "contact", key: "contact_number" },
        { label: "department", key: "department" },
        { label: "qualification", key: "qualification" },
        { label: "Designation", key: "designation" },
        // { label: "experience", key: "experience" },
        // { label: "Total Periods", key: "totalPeriods" },
        { label: "status", key: "status" },
        "actions",
      ],
      fields2: [
        { label: "S.No", key: "index" },
        { label: "name", key: "name", stickyColumn: true, tdClass: "bg-white" },
        { label: "contact", key: "contact_number" },
        { label: "department", key: "department" },
        { label: "qualification", key: "qualification" },
        { label: "Designation", key: "designation" },
        { label: "salary", key: "totalSalary" },
        { label: "status", key: "status" },
        "actions",
      ],
      currentSections: [],
      items: [],
      selected: null,
      rangeDate: null,
      myObj: {},
      depObj: {
        id: 0,
        name: "",
        campusID: this.$store.state.userData.cId,
      },
      avatarURL:
        "https://raw.githubusercontent.com/Ashwinvalento/cartoon-avatar/master/lib/images/female/110.png",
      staffImporting: false,
      staffData: [],
      idList: [],
      persistentSelectedIds: [], // Store selected IDs across page changes
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      printing: false,
      cardObj: {
        depList: [],
      },
      visibility2: false,
      visibility3: false,
      saving: false,
      savingRej: false,
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      leavingDateConfig: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        maxDate: "today",
      },
      showSalary: null,
      syncLoading: false,
      ctObj: null,
      campuses: [],
      visibility4: false,
      currentStaff: {},
      campObj: {},
      depLoading: false,
      depOptions: [],
      visibility5: false,
      slrObj: null,
      reqData: [],
      reqFields: [
        { label: "request", key: "request" },
        { label: "Request type", key: "requestCategory" },
        { label: "status", key: "status" },
        { label: "actions", key: "actions" },
      ],
      reqObj: {},
      requestOptions: [
        { text: "Due to Marriage", value: "Due to Marriage" },
        {
          text: "Behaviour issues with the students",
          value: "Behaviour issues with the students",
        },
        { text: "To get new opportunity", value: "To get new opportunity" },
        { text: "Joined Online Work", value: "Joined Online Work" },
        { text: "Due to Pregnancy", value: "Due to Pregnancy" },
        {
          text: "Termination / Management took resign",
          value: "Termination / Management took resign",
        },
        {
          text: "Due to domestic / personal issues / Mother was ill",
          value: "Due to domestic / personal issues / Mother was ill",
        },
        {
          text: "Due to Conveyance Problems /long distance / residence shifted",
          value:
            "Due to Conveyance Problems /long distance / residence shifted",
        },
        {
          text: "Migration to another Country",
          value: "Migration to another Country",
        },
        {
          text: "Prolonged Absence / Without intimation",
          value: "Prolonged Absence / Without intimation",
        },
        {
          text: "Unsatisfactory Performance",
          value: "Unsatisfactory Performance",
        },
        { text: "Due to Studies", value: "Due to Studies" },
        { text: "Due to illness", value: "Due to illness" },
        { text: "Due to own business", value: "Due to own business" },
        { text: "Adopted a baby", value: "Adopted a baby" },
        { text: "To avail Government Job", value: "To avail Government Job" },
        { text: "Due to Workload", value: "Due to Workload" },
        { text: "Contractual Employment", value: "Contractual Employment" },
        { text: "Temporary Employment", value: "Temporary Employment" },
      ],
      iussLeavingReasonsByCategory: {
        Resigned: [
          "Better Career Opportunity",
          "Personal Reasons",
          "Higher Education / Further Studies",
          "Change of Residence",
          "Family Commitments",
          "Health Reasons",
          "Better Salary",
          "Change of Profession",
          "Work-Life Balance",
          "Dissatisfaction with Management",
          "Dissatisfaction with Work Environment",
          "Migration / Relocation Abroad",
          "Personal Career Break",
          "Other (Specify)",
        ],
        Retirement: ["Retired"],
        Termination: [
          "Unsatisfactory Performance",
          "Misconduct",
          "Violation of Code of Conduct",
          "Unauthorized Absence",
          "Violation of HR Policies & Procedures",
          "Disciplinary Action",
          "Failure to Meet Probation Requirements",
          "Insubordination",
          "Failure to Follow Instructions",
          "Negligence of Duties",
          "Fraud & Misrepresentation",
          "Repeated Failure to Meet Performance Standards",
          "Contractual Grounds or Breach of Employment Terms",
          "Workplace Harassment",
          "Other (Specify)",
        ],
        Retrenchment: [
          "Organizational Restructuring",
          "Position Abolished",
          "Campus Closure",
          "Campus Merger",
          "Reduction in Workforce",
          "Department Closure",
          "Operational Redundancy",
          "Business or Operational Downsizing",
          "Other (Specify)",
        ],
      },
      leavingReasonOther: "",
      savingReq: false,
      visibility6: false,
      detailObj: {},
      faceIdLoading: false,
      showFaceIdModal: false,
      enrollmentLink: "",
      currentStaffId: null,
      showFaceId: false,
      repObj: {
        depList: [],
        sessionID: 0,
        status: "present",
        format: "",
      },
      sessionOptions: [],
      studentStatusOptions: [
        { text: "Present", value: "present" },
        { text: "Left", value: "left" },
      ],
      repExporting: false,
      visibilitySettings: false,
      savingSettings: false,
      allFields: [
        { label: "S.No", key: "index", visible: true, required: true },
        { label: "Name", key: "name", visible: true, required: true },
        {
          label: "Surname",
          key: "surname",
          visible: ["myskool_yakubov"].includes(this.$store.state.clientID),
          required: false,
        },
        {
          label: "Contact",
          key: "contact_number",
          visible: true,
          required: false,
        },
        {
          label: "Department",
          key: "department",
          visible: true,
          required: false,
        },
        {
          label: "Qualification",
          key: "qualification",
          visible: true,
          required: false,
        },
        {
          label: "Designation",
          key: "designation",
          visible: true,
          required: false,
        },
        {
          label: "Experience",
          key: "experience",
          visible: false,
          required: false,
        },
        { label: "Status", key: "status", visible: true, required: true },
        { label: "Campus", key: "campus", visible: false, required: false },
        { label: "Emp Code", key: "empCode", visible: false, required: false },
        { label: "Gender", key: "gender", visible: false, required: false },
        {
          label: "Date of Birth",
          key: "date_of_birth",
          visible: false,
          required: false,
        },
        {
          label: "Current Address",
          key: "address_current",
          visible: false,
          required: false,
        },
        {
          label: "Permanent Address",
          key: "address_permanent",
          visible: false,
          required: false,
        },
        {
          label: "Emergency Contact Person",
          key: "emergency_contact_person",
          visible: false,
          required: false,
        },
        {
          label: "Emergency Contact Relation",
          key: "emergency_contact_relation",
          visible: false,
          required: false,
        },
        {
          label: "Emergency Number",
          key: "emergency_number",
          visible: false,
          required: false,
        },
        {
          label: "Documents",
          key: "documents",
          visible: false,
          required: false,
        },
        {
          label: "Availability",
          key: "availibility",
          visible: false,
          required: false,
        },
        {
          label: "Expected Salary",
          key: "expectedSalary",
          visible: false,
          required: false,
        },
        {
          label: "Appointed On",
          key: "appointedOn",
          visible: false,
          required: false,
        },
        {
          label: "Basic Salary",
          key: "basicSalary",
          visible: false,
          required: false,
        },
        { label: "Bonuses", key: "bonuses", visible: false, required: false },
        {
          label: "Total Salary",
          key: "totalSalary",
          visible: false,
          required: false,
        },
        { label: "Note", key: "note", visible: false, required: false },
        {
          label: "Allowed Leaves",
          key: "allowedLeaves",
          visible: false,
          required: false,
        },
        { label: "Joins At", key: "joinsAt", visible: false, required: false },
        {
          label: "Account Title",
          key: "accountTitle",
          visible: false,
          required: false,
        },
        {
          label: "Account Number",
          key: "accountNumber",
          visible: false,
          required: false,
        },
        { label: "Pay Mode", key: "payMode", visible: false, required: false },
        { label: "CNIC", key: "cnic", visible: false, required: false },
        { label: "Spouse", key: "spouse", visible: false, required: false },
        {
          label: "Is Coordinator",
          key: "isCoordinator",
          visible: false,
          required: false,
        },
        {
          label: "Leaves Allowed From",
          key: "leaves_allowed_from",
          visible: false,
          required: false,
        },
        {
          label: "Leaving Date",
          key: "leaving_date",
          visible: false,
          required: false,
        },
        {
          label: "Rejoining Date",
          key: "rejoining_date",
          visible: false,
          required: false,
        },
        {
          label: "Remaining Leaves",
          key: "remaining_leaves",
          visible: false,
          required: false,
        },
        {
          label: "Card Number",
          key: "card_number",
          visible: false,
          required: false,
        },
        {
          label: "Teaching Level",
          key: "teachingLevel",
          visible: false,
          required: false,
        },
        {
          label: "Applicant Status",
          key: "applicantStatus",
          visible: false,
          required: false,
        },
        {
          label: "Registration Date",
          key: "registrationDate",
          visible: false,
          required: false,
        },
        {
          label: "Approval Date",
          key: "approvalDate",
          visible: false,
          required: false,
        },
        {
          label: "Share Percentage",
          key: "sharePerc",
          visible: false,
          required: false,
        },
        {
          label: "Grace Minutes",
          key: "graceMins",
          visible: false,
          required: false,
        },
        {
          label: "Part Timer Days",
          key: "partTimerDays",
          visible: false,
          required: false,
        },
        {
          label: "Total Periods",
          key: "totalPeriods",
          visible: false,
          required: false,
        },
        {
          label: "Can Post News Feed",
          key: "canPostNewsFeed",
          visible: false,
          required: false,
        },
      ],
      userSetting: null,
      designations: [], // [{ name, departmentID }]
      designationsLoaded: false,
      loadingDesignationSettings: false,
      newDesignation: "",
      newDesignationDepartmentID: null,
      editingDesignationIndex: -1,
      savingDesignation: false,
      visibilityDesignation: false,
      designationSetting: null,
      showDesignationSettings: false, // Track if staff-designations setting exists

      // Template related state
      showTemplateModal: false,
      templates: [],
      templateLoading: false,
      templatePage: 1,
      templateTotal: 0,
      templatePerPage: 10,
      selectedTemplate: null,
      printingTemplate: false,
      templateSearch: "",
      templateFields: [
        { key: "title", label: "Title", sortable: false },
        { key: "templateFor", label: "Type", sortable: false },
      ],
      templateLink: null,
      reportOptions: [
        { name: "ID Card", value: "id-card" },
        { name: "Offer Letter", value: "offer-letter" },
        { name: "Office Order", value: "office-order" },
      ],
      kentPrintObj: {
        type: "id-card",
        depList: [],
      },
      kentStaffPrintOptions: [
        { name: "ID Card", value: "id-card" },
        { name: "Appointment Letter", value: "appointment-letter" },
        { name: "Employment Form", value: "teachers-form" },
      ],
      generalPrintObj: {
        type: "id-card",
        depList: [],
      },
      generalStaffPrintOptions: [
        { name: "ID Card", value: "id-card" },
        { name: "Appointment Letter", value: "appointment-letter" },
        { name: "Joining Letter", value: "joining-letter" },
      ],
      showSyncedModal: false,
      selectedSyncedDetails: null,
      selectedSyncedStaffID: null,
      visibilityIncrementMenu: false,
      showBulkIncrementModal: false,
      showBulkImportIncrementModal: false,
      bulkIncrementSubmitting: false,
      bulkIncStep: "form",
      bulkIncResult: {},
      bulkIncObj: {
        depList: [0],
        type: "percentage",
        value: null,
        note: "",
        date: "",
      },
      bulkIncTypeOptions: [
        { text: "Percentage", value: "percentage" },
        { text: "Amount", value: "amount" },
        { text: "Direct", value: "direct" },
      ],
      incrementSummaryFields: [
        { key: "name", label: "Name" },
        { key: "departmentName", label: "Department" },
        {
          key: "previousBasic",
          label: "Prev. basic",
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "newBasic",
          label: "New basic",
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "incrementAmount",
          label: "Increment",
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
      importIncStep: "form",
      importIncResult: {},
      importIncFileExcludedNoAmount: 0,
      importIncObj: {
        note: "",
        date: "",
      },
      importIncrementRows: [],
      importIncrementPreview: [],
      importIncrementParseStats: {
        included: 0,
        excludedNoAmount: 0,
      },
      importIncrementFile: null,
      importIncrementSubmitting: false,
      importIncrementParsing: false,
      exportIncrementTemplateLoading: false,
      importIncrementPreviewFields: [
        { key: "tID", label: "Staff ID" },
        { key: "name", label: "Name" },
        { key: "department", label: "Department" },
        {
          key: "amount",
          label: "Amount",
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
      importIncrementSummaryFields: [
        { key: "name", label: "Name" },
        { key: "departmentName", label: "Department" },
        { key: "date", label: "Date", thClass: "text-nowrap" },
        {
          key: "previousBasic",
          label: "Prev. basic",
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "newBasic",
          label: "New basic",
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "incrementAmount",
          label: "Increment",
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
    };
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    formatMoney(val) {
      const n = Number(val);
      if (Number.isNaN(n)) return val ?? "";
      return n.toLocaleString(undefined, { maximumFractionDigits: 2 });
    },

    formatIncrementSummaryDate(value) {
      if (value === null || value === undefined || value === "") return "—";
      const s = String(value).trim();
      if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
      const d = new Date(s);
      if (!Number.isNaN(d.getTime())) {
        return d.toISOString().slice(0, 10);
      }
      return s.length > 10 ? s.slice(0, 10) : s;
    },

    staffCampusId() {
      return this.reportDomain === "myskoolhpgs" &&
        this.$store.state.userData.cId == 1
        ? this.filter.cID
        : this.$store.state.userData.cId;
    },

    openIncrementMenu() {
      if (!this.showBulkIncrement) return;
      this.visibilityIncrementMenu = true;
    },

    openBulkIncrementModal() {
      this.visibilityIncrementMenu = false;
      this.resetBulkIncrementModal();
      this.showBulkIncrementModal = true;
    },

    openBulkImportIncrementModal() {
      this.visibilityIncrementMenu = false;
      this.resetBulkImportIncrementModal();
      this.importIncObj.date = new Date().toISOString().slice(0, 10);
      this.showBulkImportIncrementModal = true;
    },

    importIncrementHistoryDate() {
      return (
        this.importIncObj.date || new Date().toISOString().slice(0, 10)
      );
    },

    resetBulkIncrementModal() {
      this.bulkIncStep = "form";
      this.bulkIncResult = {};
      this.bulkIncObj = {
        depList: [0],
        type: "percentage",
        value: null,
        note: "",
        date: new Date().toISOString().slice(0, 10),
      };
      this.bulkIncrementSubmitting = false;
    },

    resetBulkImportIncrementModal() {
      this.importIncStep = "form";
      this.importIncResult = {};
      this.importIncFileExcludedNoAmount = 0;
      this.importIncObj = {
        note: "",
        date: new Date().toISOString().slice(0, 10),
      };
      this.importIncrementRows = [];
      this.importIncrementPreview = [];
      this.importIncrementParseStats = {
        included: 0,
        excludedNoAmount: 0,
      };
      this.importIncrementFile = null;
      this.importIncrementSubmitting = false;
      this.importIncrementParsing = false;
      if (this.$refs.importIncrementFile) {
        this.$refs.importIncrementFile.value = "";
      }
    },

    setBulkIncDep() {
      if (!Array.isArray(this.bulkIncObj.depList)) {
        this.bulkIncObj.depList = [this.bulkIncObj.depList];
      }
      if (this.bulkIncObj.depList.at(-1) == 0) {
        this.bulkIncObj.depList = [0];
      } else {
        this.bulkIncObj.depList = this.bulkIncObj.depList.filter((el) => el != 0);
      }
    },

    bulkIncrementDeptSummary() {
      const list = this.bulkIncObj.depList || [];
      if (!list.length || list.includes(0)) {
        return this.$t("All departments");
      }
      return `${list.length} ${this.$t("department(s)")}`;
    },

    bulkIncrementTypeLabel() {
      const opt = this.bulkIncTypeOptions.find(
        (o) => o.value === this.bulkIncObj.type
      );
      return opt ? this.$t(opt.text) : this.bulkIncObj.type;
    },

    async confirmBulkIncrement() {
      const value = Number(this.bulkIncObj.value);
      if (Number.isNaN(value) || value < 0) {
        this.$bvToast.toast(this.$t("Please enter a valid value"), {
          title: this.$t("Validation"),
          variant: "warning",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      const result = await Swal.fire({
        title: this.$t("Confirm bulk increment?"),
        html: `<p>${this.$t("Type")}: <strong>${this.bulkIncrementTypeLabel()}</strong></p>
          <p>${this.$t("Value")}: <strong>${value}</strong></p>
          <p>${this.$t("Departments")}: <strong>${this.bulkIncrementDeptSummary()}</strong></p>
          <p class="text-muted small mb-0">${this.$t("Only staff with status Present will be updated.")}</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Update"),
        cancelButtonText: this.$t("Cancel"),
      });

      if (result.isConfirmed) {
        await this.submitBulkIncrement();
      }
    },

    resolveBulkDepartmentIds() {
      let departmentIDs = Array.isArray(this.bulkIncObj.depList)
        ? [...this.bulkIncObj.depList]
        : [this.bulkIncObj.depList];
      if (!departmentIDs.length || departmentIDs.includes(0)) {
        return [0];
      }
      return departmentIDs;
    },

    async submitBulkIncrement() {
      this.bulkIncrementSubmitting = true;
      try {
        const body = {
          campusID: this.staffCampusId(),
          userID: this.$store.state.userData.userID,
          departmentIDs: this.resolveBulkDepartmentIds(),
          type: this.bulkIncObj.type,
          value: Number(this.bulkIncObj.value),
          note: this.bulkIncObj.note || "",
          date: this.bulkIncObj.date || new Date().toISOString().slice(0, 10),
        };

        const url =
          this.$store.state.domain +
          "StaffIncrementHistory/BulkIncrement?db=" +
          encodeURIComponent(this.$store.state.userData.db);

        const res = await this.post({
          url,
          body,
          token: this.$store.state.userData.token,
          context: this,
          allResponse: true,
          showError: true,
        });

        if (res && String(res.status).toLowerCase() === "success") {
          this.bulkIncResult = res;
          this.bulkIncStep = "summary";
          this.$bvToast.toast(
            `${this.$t("Updated")} ${res.updatedCount || 0}`,
            {
              title: this.$t("Success"),
              variant: "success",
              toaster: "b-toaster-top-center",
            }
          );
          await this.LoadData();
        }
      } finally {
        this.bulkIncrementSubmitting = false;
      }
    },

    closeBulkIncrementSummary() {
      this.showBulkIncrementModal = false;
    },

    async fetchPresentStaffForIncrementExport() {
      const baseUrl = `${this.$store.state.domain}staff/LoadDataPagination`;
      const urlParams = new URLSearchParams({
        db: this.$store.state.userData.db,
        cId: this.staffCampusId(),
        dptID: this.filter.dep,
        status: "present",
        depname: "",
        page: 1,
        applicantStatus: "",
        appointedFrom: this.filter.appointedFrom || "",
        appointedTo: this.filter.appointedTo || "",
        leavingFrom: this.filter.leavingFrom || "",
        leavingTo: this.filter.leavingTo || "",
        designation: this.filter.designation || "",
        gender: this.filter.gender || "",
        sortBy: this.sortBy,
        sortOrder: this.sortOrder,
        pageSize: 10000,
      });

      const response = await this.get({
        url: `${baseUrl}?${urlParams.toString()}`,
        token: this.$store.state.userData.token,
        dashboard: true,
      });

      if (response && Array.isArray(response.data)) {
        return response.data;
      }
      if (Array.isArray(response)) {
        return response;
      }
      return [];
    },

    async exportIncrementTemplate() {
      this.exportIncrementTemplateLoading = true;
      try {
        let dataArray = [];
        if (this.persistentSelectedIds.length > 0) {
          const baseUrl = `${this.$store.state.domain}Staff/LoadDataSelected`;
          const urlParams = new URLSearchParams({
            db: this.$store.state.userData.db,
            cID: this.staffCampusId(),
            tIDs: this.persistentSelectedIds.join(","),
          });
          const response = await this.get({
            url: `${baseUrl}?${urlParams.toString()}`,
            token: this.$store.state.userData.token,
          });
          if (response && response.data && Array.isArray(response.data)) {
            dataArray = response.data;
          } else if (Array.isArray(response)) {
            dataArray = response;
          }
        } else {
          dataArray = await this.fetchPresentStaffForIncrementExport();
        }

        dataArray = dataArray.filter(
          (item) => String(item.status || "").toLowerCase() === "present"
        );

        if (!dataArray.length) {
          this.$bvToast.toast(this.$t("No present staff found to export"), {
            title: this.$t("Warning"),
            variant: "warning",
            toaster: "b-toaster-top-center",
          });
          return;
        }

        const expData = dataArray.map((item) => ({
          tID: item.id,
          name: item.name,
          department: item.department ? item.department.name : "",
          amount: "",
        }));

        const stamp = new Date().toISOString().slice(0, 10);
        const worksheet = buildFormattedWorksheet(expData, {
          columns: STAFF_INCREMENT_IMPORT_COLUMNS,
          title: this.$t("Staff Increment Import"),
          subtitle: `${this.$t("Exported")} ${stamp}`,
        });

        await writeWorkbookToFile(
          worksheet,
          `staff-increment-import-${stamp}.xlsx`,
          "Increment"
        );

        this.$bvToast.toast(
          `${this.$t("Exported")} ${expData.length} ${this.$t("rows")}`,
          {
            title: this.$t("Success"),
            variant: "success",
            toaster: "b-toaster-top-center",
          }
        );
      } catch (e) {
        console.error(e);
        this.$bvToast.toast(this.$t("Failed to export data"), {
          title: this.$t("Error"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.exportIncrementTemplateLoading = false;
      }
    },

    findIncrementImportHeaderRowIndex(rows) {
      if (!rows || !rows.length) return -1;
      const scanLimit = Math.min(rows.length, 15);
      for (let i = 0; i < scanLimit; i += 1) {
        const headers = (rows[i] || []).map((h) =>
          (h || "").toString().toLowerCase().trim()
        );
        const indexes = this.getIncrementImportColumnIndexes(headers);
        if (indexes.tID !== -1 && indexes.amount !== -1) {
          return i;
        }
      }
      return -1;
    },

    incrementImportAmountMissing(amountRaw) {
      if (amountRaw === null || amountRaw === undefined) return true;
      const text = String(amountRaw).trim();
      if (!text) return true;
      const n = Number(text.replace(/,/g, ""));
      return Number.isNaN(n);
    },

    getIncrementImportColumnIndexes(headers) {
      const exact = (label) => headers.findIndex((h) => h === label);
      const includes = (...parts) => {
        for (const part of parts) {
          const idx = headers.findIndex(
            (h) => h === part || (part.length > 2 && h.includes(part))
          );
          if (idx !== -1) return idx;
        }
        return -1;
      };
      return {
        tID:
          exact("staff id") !== -1
            ? exact("staff id")
            : includes("staff id", "staffid", "tid", "t id") !== -1
            ? includes("staff id", "staffid", "tid", "t id")
            : exact("id"),
        name: exact("name"),
        department:
          exact("department") !== -1
            ? exact("department")
            : includes("department", "dept"),
        amount:
          exact("amount") !== -1
            ? exact("amount")
            : includes("amount", "increment"),
      };
    },

    parseIncrementImportRow(row, indexes) {
      const cell = (idx) =>
        idx >= 0 && row[idx] !== null && row[idx] !== undefined
          ? String(row[idx]).trim()
          : "";

      const tIDRaw = cell(indexes.tID);
      const tID = Number(tIDRaw);
      const amountCell =
        indexes.amount >= 0 && row[indexes.amount] !== null && row[indexes.amount] !== undefined
          ? row[indexes.amount]
          : "";
      const amountRaw =
        typeof amountCell === "number"
          ? String(amountCell)
          : String(amountCell).trim();

      if (!tIDRaw || Number.isNaN(tID)) {
        return { kind: "skip" };
      }

      if (this.incrementImportAmountMissing(amountRaw)) {
        return {
          kind: "excluded",
          tID,
          name: cell(indexes.name),
          department: cell(indexes.department),
        };
      }

      const amount = Number(amountRaw.replace(/,/g, ""));
      return {
        kind: "included",
        item: {
          tID,
          name: cell(indexes.name),
          department: cell(indexes.department),
          amount,
        },
      };
    },

    async onIncrementImportFileSelected(event) {
      const input = event.target;
      const file = input.files && input.files[0];
      if (!file) return;

      this.importIncrementParsing = true;
      this.importIncrementFile = file;
      this.importIncrementRows = [];
      this.importIncrementPreview = [];
      this.importIncrementParseStats = {
        included: 0,
        excludedNoAmount: 0,
      };
      try {
        await this.$nextTick();
        const rows = await readXlsxFile(file);
        await new Promise((resolve) => setTimeout(resolve, 0));
        if (!rows || rows.length < 2) {
          this.$bvToast.toast(
            this.$t("File must have a header row and at least one data row"),
            {
              title: this.$t("Invalid file"),
              variant: "warning",
              toaster: "b-toaster-top-center",
            }
          );
          this.importIncrementRows = [];
          this.importIncrementPreview = [];
          this.importIncrementParseStats = {
            included: 0,
            excludedNoAmount: 0,
          };
          return;
        }

        const headerRowIndex = this.findIncrementImportHeaderRowIndex(rows);
        if (headerRowIndex === -1) {
          this.$bvToast.toast(
            this.$t('Columns "Staff ID" and "Amount" are required'),
            {
              title: this.$t("Invalid format"),
              variant: "warning",
              toaster: "b-toaster-top-center",
            }
          );
          this.importIncrementRows = [];
          this.importIncrementPreview = [];
          this.importIncrementParseStats = {
            included: 0,
            excludedNoAmount: 0,
          };
          return;
        }

        const headers = rows[headerRowIndex].map((h) =>
          (h || "").toString().toLowerCase().trim()
        );
        const indexes = this.getIncrementImportColumnIndexes(headers);

        const parsed = [];
        let excludedNoAmount = 0;
        for (let i = headerRowIndex + 1; i < rows.length; i += 1) {
          const result = this.parseIncrementImportRow(rows[i], indexes);
          if (!result || result.kind === "skip") continue;
          if (result.kind === "excluded") {
            excludedNoAmount += 1;
            continue;
          }
          if (result.kind === "included" && result.item) {
            parsed.push(result.item);
          }
        }

        this.importIncrementRows = parsed;
        this.importIncrementPreview = parsed.slice(0, 50);
        this.importIncrementParseStats = {
          included: parsed.length,
          excludedNoAmount,
        };

        if (!parsed.length) {
          const msg = excludedNoAmount
            ? `${this.$t("No rows with amount to import")}. ${excludedNoAmount} ${this.$t(
                "excluded (no amount entered)"
              )}.`
            : this.$t("No valid rows found in file");
          this.$bvToast.toast(msg, {
            title: this.$t("Warning"),
            variant: "warning",
            toaster: "b-toaster-top-center",
          });
        }
      } catch (err) {
        console.error(err);
        this.$bvToast.toast(this.$t("Failed to read file"), {
          title: this.$t("Error"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        this.importIncrementRows = [];
        this.importIncrementPreview = [];
        this.importIncrementParseStats = {
          included: 0,
          excludedNoAmount: 0,
        };
      } finally {
        this.importIncrementParsing = false;
      }
    },

    async submitImportIncrement() {
      if (!this.importIncrementRows.length) {
        this.$bvToast.toast(
          this.importIncrementParseStats.excludedNoAmount
            ? this.$t(
                "All rows were excluded because amount is missing. Enter amount on at least one row."
              )
            : this.$t("Import a file with at least one row"),
          {
            title: this.$t("Validation"),
            variant: "warning",
            toaster: "b-toaster-top-center",
          }
        );
        return;
      }

      this.importIncrementSubmitting = true;
      try {
        const body = {
          campusID: this.staffCampusId(),
          userID: this.$store.state.userData.userID,
          note: this.importIncObj.note || "",
          date: this.importIncrementHistoryDate(),
          rows: this.importIncrementRows,
        };

        const url =
          this.$store.state.domain +
          "StaffIncrementHistory/ImportIncrement?db=" +
          encodeURIComponent(this.$store.state.userData.db);

        const res = await this.post({
          url,
          body,
          token: this.$store.state.userData.token,
          context: this,
          allResponse: true,
          showError: true,
        });

        if (res && String(res.status).toLowerCase() === "success") {
          this.importIncFileExcludedNoAmount =
            this.importIncrementParseStats.excludedNoAmount || 0;
          this.importIncResult = res;
          this.importIncStep = "summary";
          const fileExcluded = this.importIncFileExcludedNoAmount;
          let toastMsg = `${this.$t("Updated")} ${res.updatedCount || 0}, ${this.$t(
            "Skipped"
          )} ${res.skippedCount || 0}`;
          if (fileExcluded) {
            toastMsg += `, ${fileExcluded} ${this.$t(
              "excluded from file (no amount)"
            )}`;
          }
          this.$bvToast.toast(toastMsg, {
            title: this.$t("Success"),
            variant: "success",
            toaster: "b-toaster-top-center",
          });
          this.importIncrementSubmitting = false;
          this.LoadData();
          return;
        }
      } finally {
        this.importIncrementSubmitting = false;
      }
    },

    closeImportIncrementSummary() {
      this.showBulkImportIncrementModal = false;
    },

    getPicturePreview(url) {
      if (!url) return "";
      if (String(url).startsWith("blob:")) return url;
      return getMediaPreviewUrl(url, "Image");
    },
    onPicturePreviewError(event, url) {
      if (!url || String(url).startsWith("blob:")) return;
      handleDrivePreviewError(event, url, "image");
    },

    showSyncedDetails(details, staffID) {
      if (details) {
        this.selectedSyncedDetails = details;
        this.selectedSyncedStaffID = staffID;
        this.showSyncedModal = true;
      }
    },

    async deleteSyncedCredential() {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: "You won't be able to revert this credential deletion!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "staff/RemoveSyncedCredential?db=" +
            encodeURIComponent(this.$store.state.userData.db) +
            "&credID=" +
            this.selectedSyncedDetails.id +
            "&staffID=" +
            this.selectedSyncedStaffID +
            "&userID=" +
            this.$store.state.userData.userID,
          message: this.$t("Synced Credential deleted successfully."),
          context: this,
          body: null,
          token: this.$store.state.userData.token,
        });
        if (status) {
          this.showSyncedModal = false;
          this.LoadData();
        }
      }
    },

    setFocus() {
      // Auto focus the search input
      this.$nextTick(() => {
        if (this.$refs.searchInput) {
          this.$refs.searchInput.focus();
        }
      });
    },

    async LoadReqData(id) {
      this.reqData = [];
      var obj = {
        url:
          this.$store.state.domain +
          "StaffRequests/LoadStaffData?db=" +
          this.$store.state.userData.db +
          "&tID=" +
          id,
        token: this.$store.state.userData.token,
      };
      this.reqData = await this.get(obj);
      // console.log(this.reqData);
    },
    async openLeaveReq(item) {
      this.reqObj = {
        id: 0,
        staffID: item.id,
        campusID: item.campusID,
        requestCategory: "Left",
        request: "",
        requestedOn: new Date().toJSON(),
        leavingDate: null,
        note: "",
        attachment: "",
        status: "pending",
        requestedBy: this.$store.state.userData.userID,
        approvedBy: 0,
      };
      this.docList = [];

      await this.LoadReqData(item.id);

      let dt = item.appointedOn
        ? new Date(item.appointedOn).toLocaleDateString("en-UK", {
            year: "numeric",
            day: "numeric",
            month: "short",
          })
        : "";
      this.sidebarTitle = `${item.name} - ${item.designation}<br/>${dt}`;
      this.visibility5 = true;
    },
    CheckReqDate() {
      var elem = this.$refs["req_date"];
      if (!this.reqObj.requestedOn) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckReqReason() {
      var elem = this.$refs["req_reason"];
      if (this.reqObj.request.trim() == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async saveLeaveReq() {
      if (this.CheckReqReason() == true && this.CheckReqDate() == true) {
        this.reqObj.leavingDate = this.reqObj.requestedOn;
        // console.log(this.reqObj);
        this.savingReq = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "StaffRequests/Save?db=" +
            this.$store.state.userData.db +
            "&userID=" +
            this.$store.state.userData.userID +
            "&cID=" +
            this.$store.state.userData.cId,
          body: this.reqObj,
          message: this.$t("Request saved successfully!"),
          context: this,
          token: this.$store.state.userData.token,
        });
        this.savingReq = false;
        if (status) {
          this.visibility5 = false;
        }
      }
    },
    showReqDetails(item) {
      this.detailObj = { ...item };
      this.visibility6 = true;
    },
    isImage(url) {
      return isImageUrl(url);
    },
    openFile(url) {
      window.open(url, "_blank");
    },
    removeDoc(index) {
      this.docList.splice(index, 1);
      this.reqObj.attachment = this.docList.join(",");
    },
    async addDoc() {
      if (this.$refs.reqDocs.files.length > 0) {
        let docs = Array.from(this.$refs.reqDocs.files);
        this.docLoading = true;
        try {
          const uploaded = await uploadToMySkool(docs);
          getUploadedPaths(uploaded).forEach((path) => {
            this.docList.push(path);
          });
          this.reqObj.attachment = this.docList.join(",");
        } catch (err) {
          console.error(err);
          this.$bvToast.toast("Failed to upload files.", {
            title: this.$t("Error"),
            variant: "danger",
          });
        } finally {
          this.docLoading = false;
          this.$refs.reqDocs.value = "";
        }
      }
    },

    openCh(item) {
      this.currentStaff = { ...item };
      this.campObj = {
        tID: this.currentStaff.id,
        newCampus: 0,
        departmentID: 0,
        designation: this.currentStaff.designation,
        date: new Date().toJSON(),
        previousCampus: this.currentStaff.campusID,
        userID: this.$store.state.userData.userID,
      };

      this.visibility4 = true;
      this.depOptions = [];
    },
    async LoadDepByCamp() {
      this.depLoading = true;
      this.campObj.departmentID = 0;

      var obj = {
        url:
          this.$store.state.domain +
          "StaffDepartments?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.campObj.newCampus,
        token: this.$store.state.userData.token,
      };
      this.depOptions = await this.get(obj);
      this.depLoading = false;
    },
    checkChCamp() {
      var elem = this.$refs["ch_camp"];
      if (this.campObj.newCampus == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkChDep() {
      var elem = this.$refs["ch_dep"];
      if (this.campObj.departmentID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkChDesig() {
      var elem = this.$refs["ch_des"];
      if (this.campObj.designation == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkChDate() {
      var elem = this.$refs["ch_date"];
      if (!this.campObj.date) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async saveCh() {
      this.checkChCamp();
      this.checkChDep();
      this.checkChDesig();
      this.checkChDate();
      if (
        this.checkChCamp() == false ||
        this.checkChDep() == false ||
        this.checkChDesig() == false ||
        this.checkChDate() == false
      ) {
        this.$bvToast.toast(this.$t("Please select all the required fields"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
      // else if (this.chObj.previousCampus == this.chObj.newCampus) {
      //   this.$bvToast.toast("Current campus and transfer campus are same", {
      //     title: this.$t("Error!"),
      //     variant: "danger",
      //     toaster: "b-toaster-top-center",
      //   });
      // }
      else {
        console.log(this.campObj);
        // let result = await Swal.fire({
        //   title: this.$t("Are you sure?"),
        //   text: "Do you want to transfer the staff?",
        //   icon: "warning",
        //   showCancelButton: true,
        //   confirmButtonColor: "#d33",
        //   cancelButtonColor: "#3085d6",
        //   confirmButtonText: "Yes!",
        // });

        // if (result.isConfirmed) {
        //   this.request = true;

        //   // console.log(data);
        //   let status = await this.post({
        //     url:
        //       this.$store.state.domain +
        //       "Staff/TransferCampus?db=" +
        //       this.$store.state.userData.db,
        //     body: this.campObj,
        //     message: "Staff transferred successfully!",
        //     context: this,
        //     token: this.$store.state.userData.token,
        //   });
        //   this.request = false;
        //   if (status) {
        //     this.visibility4 = false;
        //     this.LoadData();
        //   }
        // }
      }
    },

    async syncApp() {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: "This will syncronize mobile accounts.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, Sync it!",
      });

      if (result.isConfirmed) {
        this.syncLoading = true;
        var status = this.get({
          url:
            this.$store.state.domain +
            "staff/SyncAccounts?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&userID=" +
            this.$store.state.userData.userID,
          message: this.$t("Accounts synced successfully!"),
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.syncLoading = false;
      }
    },

    getDepName(id) {
      const depId = Number(id) || 0;
      if (!depId) return "";
      let obj = this.departments.find((el) => Number(el.id) === depId);
      return obj ? obj.name : "";
    },
    getCampus(id) {
      let obj = this.campuses.find((el) => el.id == id);
      return obj ? obj.branch : "";
    },
    async LoadCampuses() {
      var obj = {
        url:
          this.$store.state.domain +
          "campuses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.campuses = await this.get(obj);
    },
    staffSelect(row) {
      this.idList = row.reduce((acc, el) => {
        acc.push(el.id);
        return acc;
      }, []);

      // Update persistent selections by merging with current page selections
      this.updatePersistentSelections();

      console.log("Current page selections:", this.idList);
      console.log("Total persistent selections:", this.persistentSelectedIds);
    },
    updatePersistentSelections() {
      // Get IDs of items on current page that are currently selected
      const currentPageSelectedIds = this.idList;

      // Get IDs of items on current page that are not currently selected (deselected)
      const currentPageDeselectedIds = this.items
        .filter((item) => this.persistentSelectedIds.includes(item.id))
        .map((item) => item.id)
        .filter((id) => !currentPageSelectedIds.includes(id));

      // Remove deselected items from persistent storage
      this.persistentSelectedIds = this.persistentSelectedIds.filter(
        (id) => !currentPageDeselectedIds.includes(id)
      );

      // Add newly selected items to persistent storage
      const newSelections = currentPageSelectedIds.filter(
        (id) => !this.persistentSelectedIds.includes(id)
      );
      this.persistentSelectedIds = [
        ...this.persistentSelectedIds,
        ...newSelections,
      ];
    },
    unselect() {
      this.$refs.selectableTable.clearSelected();
      this.idList = [];
      this.persistentSelectedIds = [];
    },
    restoreSelections() {
      // Restore selections from persistent storage
      if (this.persistentSelectedIds.length > 0 && this.$refs.selectableTable) {
        // Find items that match the persistent IDs in current page
        const itemsToSelect = this.items.filter((item) =>
          this.persistentSelectedIds.includes(item.id)
        );

        if (itemsToSelect.length > 0) {
          // Update idList with current page selections only
          this.idList = itemsToSelect.map((item) => item.id);

          // Select the rows in the table
          this.$refs.selectableTable.selectRow(itemsToSelect);
        } else {
          // No items on current page are selected, clear current page selection
          this.idList = [];
        }
      }
    },
    printIDs() {
      if (this.persistentSelectedIds.length > 0) {
        this.printing = true;

        if (
          this.reportDomain === "myskoolsmarthf" &&
          this.$store.state.userData.cId == 2
        ) {
          const routeData = this.$router.resolve({
            name: "smart-hassan-staff-id-card",
            query: {
              staffIDs: this.persistentSelectedIds.join(","),
              cID: String(this.$store.state.userData.cId),
              db: this.$store.state.userData.db,
            },
          });
          window.open(routeData.href, "_blank", "noopener,noreferrer");
          this.printing = false;
          return;
        }

        // Kent / Speak & Spell — Vue staff ID card (campus name + logo from API)
        if (isCampusBrandedStaffIdCardDomain(this.reportDomain)) {
          this.$router.push({
            name: "kent-staff-id-card",
            query: {
              cID: String(this.$store.state.userData.cId),
              db: this.$store.state.userData.db,
              status: this.currentStatus,
              staffIDs: this.persistentSelectedIds.join(","),
            },
          });
          this.printing = false;
          return;
        }

        var url =
          `https://${this.reportDomain}.myskool.app/Certificate/StaffCard?dbb=` +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&staffID=" +
          this.persistentSelectedIds +
          "&depID=0";
        window.open(url, "_blank");
        this.printing = false;
      } else {
        this.$bvModal.show("modal-cards");
      }
    },
    openKentStaffPrint() {
      this.kentPrintObj.type = "id-card";
      this.kentPrintObj.depList = [];
      this.$bvModal.show("modal-kent-staff-print");
    },
    setKentPrintDep() {
      if (!Array.isArray(this.kentPrintObj.depList)) {
        this.kentPrintObj.depList = [];
        return;
      }
      if (this.kentPrintObj.depList.at(-1) === 0) {
        this.kentPrintObj.depList = [0];
      } else {
        this.kentPrintObj.depList = this.kentPrintObj.depList.filter(
          (el) => el !== 0
        );
      }
    },
    checkKentPrintType() {
      const elem = this.$refs.kent_print_type;
      if (!elem) return true;
      if (!this.kentPrintObj.type) {
        return (elem.state = false);
      }
      return (elem.state = true);
    },
    printKentStaffReport() {
      if (this.checkKentPrintType() !== true) {
        return;
      }

      const reportType = this.kentPrintObj.type;

      if (reportType === "id-card") {
        const query = {
          cID: String(this.$store.state.userData.cId),
          db: this.$store.state.userData.db,
          status: this.currentStatus,
        };

        if (this.persistentSelectedIds.length) {
          query.staffIDs = this.persistentSelectedIds.join(",");
        } else {
          const depList = this.kentPrintObj.depList || [];
          const depElem = this.$refs.kent_print_dep;
          if (!depList.length) {
            if (depElem) depElem.state = false;
            this.$bvToast.toast(
              this.$t("Please select at least one department."),
              {
                title: this.$t("Error!"),
                variant: "warning",
                toaster: "b-toaster-top-center",
              }
            );
            return;
          }
          if (depElem) depElem.state = true;
          query.depID = depList.join(",");
        }

        this.$bvModal.hide("modal-kent-staff-print");
        this.printing = true;
        this.$router.push({
          name: "kent-staff-id-card",
          query,
        });
        this.printing = false;
        return;
      }

      if (this.reportDomain !== "myskoolkentschool") {
        this.$bvToast.toast("Unsupported print type selected.", {
          title: "Error",
          variant: "danger",
          toaster: "b-toaster-top-center",
          solid: true,
        });
        return;
      }

      const routeName =
        reportType === "appointment-letter"
          ? "kent-appointment-letter"
          : reportType === "teachers-form"
          ? "kent-teachers-form"
          : "";

      if (!routeName) {
        this.$bvToast.toast("Unsupported print type selected.", {
          title: "Error",
          variant: "danger",
          toaster: "b-toaster-top-center",
          solid: true,
        });
        return;
      }

      const db = this.$store.state.userData.db;
      const cID = this.$store.state.userData.cId;
      const query = {
        cID: String(cID),
        db,
        status: this.currentStatus,
      };

      if (this.persistentSelectedIds.length) {
        query.staffIDs = this.persistentSelectedIds.join(",");
      } else {
        const depList = this.kentPrintObj.depList || [];
        const depElem = this.$refs.kent_print_dep;
        if (!depList.length) {
          if (depElem) depElem.state = false;
          this.$bvToast.toast(this.$t("Please select at least one department."), {
            title: this.$t("Error!"),
            variant: "warning",
            toaster: "b-toaster-top-center",
          });
          return;
        }
        if (depElem) depElem.state = true;
        query.depID = depList.join(",");
      }

      this.$bvModal.hide("modal-kent-staff-print");
      this.printing = true;
      openKentStaffDocumentRoute(this, routeName, query);
      this.printing = false;
    },
    openGeneralStaffPrint() {
      this.generalPrintObj.type = "id-card";
      this.generalPrintObj.depList = [];
      this.$bvModal.show("modal-general-staff-print");
    },
    setGeneralPrintDep() {
      if (!Array.isArray(this.generalPrintObj.depList)) {
        this.generalPrintObj.depList = [];
        return;
      }
      if (this.generalPrintObj.depList.at(-1) === 0) {
        this.generalPrintObj.depList = [0];
      } else {
        this.generalPrintObj.depList = this.generalPrintObj.depList.filter(
          (el) => el !== 0
        );
      }
    },
    checkGeneralPrintType() {
      const elem = this.$refs.general_print_type;
      if (!elem) return true;
      if (!this.generalPrintObj.type) {
        return (elem.state = false);
      }
      return (elem.state = true);
    },
    printGeneralStaffReport() {
      if (this.checkGeneralPrintType() !== true) {
        return;
      }

      const reportType = this.generalPrintObj.type;

      if (reportType === "id-card") {
        this.$bvModal.hide("modal-general-staff-print");
        this.printIDs();
        return;
      }

      const routeName =
        reportType === "appointment-letter"
          ? "appointment-letter"
          : reportType === "joining-letter"
          ? "joining-letter"
          : reportType;

      if (!routeName) {
        this.$bvToast.toast("Unsupported print type selected.", {
          title: "Error",
          variant: "danger",
          toaster: "b-toaster-top-center",
          solid: true,
        });
        return;
      }

      const db = this.$store.state.userData.db;
      const cID = this.$store.state.userData.cId;
      const query = {
        cID: String(cID),
        db,
        status: this.currentStatus,
      };

      if (this.persistentSelectedIds.length) {
        query.staffIDs = this.persistentSelectedIds.join(",");
      } else {
        const depList = this.generalPrintObj.depList || [];
        const depElem = this.$refs.general_print_dep;
        if (!depList.length) {
          if (depElem) depElem.state = false;
          this.$bvToast.toast(this.$t("Please select at least one department."), {
            title: this.$t("Error!"),
            variant: "warning",
            toaster: "b-toaster-top-center",
          });
          return;
        }
        if (depElem) depElem.state = true;
        query.depID = depList.join(",");
      }

      this.$bvModal.hide("modal-general-staff-print");
      this.printing = true;
      openKentStaffDocumentRoute(this, routeName, query);
      this.printing = false;
    },
    reportSelected(reportType) {
      if (reportType == "id-card") {
        // normal flow
        this.printIDs();
      } else {
        if (this.persistentSelectedIds.length > 0) {
          const url =
            `https://${this.reportDomain}.myskool.app/Certificate/ShowStaff?type=${reportType}&dbb=` +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&tID=" +
            this.persistentSelectedIds +
            "&depID=0";

          window.open(url, "_blank");
        } else {
          this.$bvToast.toast("Please select staff members to print report.", {
            title: "No Selection",
            variant: "warning",
            toaster: "b-toaster-top-center",
            solid: true,
          });
        }
      }
    },

    // Template specific methods
    openTemplateModal() {
      this.templatePage = 1;
      this.selectedTemplate = null;
      this.templateSearch = "";
      this.showTemplateModal = true;
      this.fetchTemplates();
    },

    async fetchTemplates() {
      this.templateLoading = true;
      try {
        const params = new URLSearchParams({
          db: this.$store.state.userData.db,
          cID: this.$store.state.userData.cId,
          page: this.templatePage,
          pageSize: this.templatePerPage,
          templateFor: "Staff",
        });

        if (this.templateSearch) {
          params.append("search", this.templateSearch);
        }

        const obj = {
          url:
            this.$store.state.domain +
            "TemplateData/GetByPagination?" +
            params.toString(),
          token: this.$store.state.userData.token,
          dashboard: true,
        };

        const res = await this.get(obj);

        if (res && res.status === "success" && Array.isArray(res.data)) {
          this.templates = res.data;
          this.templateTotal = res.totalCount || 0;
        } else if (res && Array.isArray(res.data)) {
          this.templates = res.data;
          this.templateTotal = res.total || res.totalCount || 0;
        } else {
          this.templates = [];
          this.templateTotal = 0;
        }
      } catch (error) {
        console.error("Error fetching templates:", error);
        this.$bvToast.toast("Failed to load templates", {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
      } finally {
        this.templateLoading = false;
      }
    },

    printWithTemplate() {
      if (!this.selectedTemplate || this.persistentSelectedIds.length === 0) {
        return;
      }

      this.printingTemplate = true;
      try {
        // Construct the print URL
        // Following the pattern of student data printing: Certificate/DataTemplate
        const url =
          `https://${this.reportDomain}.myskool.app/Certificate/DataTemplate?dbb=` +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&id=" +
          this.persistentSelectedIds.join(",") +
          "&templateID=" +
          this.selectedTemplate.id +
          "&type=Staff";

        window.open(url, "_blank");
      } catch (error) {
        console.error("Error printing template:", error);
      } finally {
        this.printingTemplate = false;
      }
    },
    async updatePolicy() {
      this.updatingPolicy = true;
      try {
        const obj = {
          url:
            this.$store.state.domain +
            "Staff/LoadPolicyAndUpdateSalary?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          token: this.$store.state.userData.token,
        };

        const response = await this.get(obj);
        console.log("Policy update response:", response);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("Success"),
            text: "Policy and salary updated successfully!",
            icon: "CheckIcon",
            variant: "success",
          },
        });

        // Refresh the grid data after policy update
        this.loadData();
      } catch (error) {
        console.error("Error updating policy:", error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("Error"),
            text: "Failed to update policy and salary. Please try again.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.updatingPolicy = false;
      }
    },
    async printFileCovers() {
      if (!this.persistentSelectedIds.length) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "No Selection",
            text: "Please select staff members to print file covers",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      // Open file covers through its own route in a new tab
      const routeData = this.$router.resolve({
        name: "file-cover",
        query: {
          db: this.$store.state.userData.db,
          cID: String(this.$store.state.userData.cId),
          staffIDs: this.persistentSelectedIds.join(","),
        },
      });
      window.open(routeData.href, "_blank", "noopener,noreferrer");
    },
    getSelectedStaffFromGrid() {
      // Get selected staff data from the current grid data
      // This only works for staff on the current page
      if (this.items && this.items.length > 0) {
        const currentPageStaff = this.items.filter(
          (item) =>
            this.persistentSelectedIds.includes(item.id) ||
            this.persistentSelectedIds.includes(item.staffId) ||
            this.persistentSelectedIds.includes(item.rfID)
        );

        console.log("Current page staff found:", currentPageStaff.length);
        console.log("Total selected IDs:", this.persistentSelectedIds.length);

        // If we don't have all selected staff on current page, return empty array
        // to force API call for complete data
        if (currentPageStaff.length < this.persistentSelectedIds.length) {
          console.log(
            "Not all selected staff on current page, will use API call"
          );
          return [];
        }

        return currentPageStaff;
      }
      return [];
    },
    async getStaffDataForFileCovers() {
      try {
        console.log("Selected IDs:", this.persistentSelectedIds);

        // Build the full API URL like other calls in this file
        const baseUrl = this.$store.state.domain + "Staff/LoadDataSelected";
        const urlParams = new URLSearchParams({
          db: this.$store.state.userData.db,
          cID: this.$store.state.userData.cId,
          tIDs: this.persistentSelectedIds.join(","), // Pass selected IDs as comma-separated string
        });

        const apiUrl = `${baseUrl}?${urlParams.toString()}`;
        console.log("Full API URL:", apiUrl);

        // Use the same format as other API calls in this file
        const response = await this.get({
          url: apiUrl,
          token: this.$store.state.userData.token,
        });

        console.log("API Response:", response);

        // Return the data directly since this API returns only selected staff
        if (response && response.data) {
          console.log("Selected staff data:", response.data);
          return response.data;
        } else if (response && Array.isArray(response)) {
          console.log("Selected staff data (direct array):", response);
          return response;
        }

        console.log("No data found in response");
        return [];
      } catch (error) {
        console.error("Error fetching staff data:", error);
        throw error;
      }
    },
    generateFileCoverPrint(data) {
      console.log("Generating file cover for data:", data);

      // Create file cover cards for each staff member
      const fileCoverCards = data
        .map((item, index) => {
          // Safely extract data with fallbacks
          const staffName =
            item.staffName || item.name || item.fullName || "N/A";
          const designation =
            item.designation || item.position || item.jobTitle || "N/A";
          const rfID = item.rfID || item.rfid || item.RFID || item.id || "N/A";

          // Handle department data - use getDepName method for proper lookup
          let departmentName = "N/A";
          if (item.departmentID) {
            departmentName = this.getDepName(item.departmentID);
          } else if (item.department) {
            if (typeof item.department === "string") {
              departmentName = item.department;
            } else if (item.department.name) {
              departmentName = item.department.name;
            }
          } else if (item.departmentName) {
            departmentName = item.departmentName;
          }

          // Handle joining date
          const joiningDate = this.formatDate(
            item.appointedOn ||
              item.joiningDate ||
              item.appointmentDate ||
              item.createdAt
          );

          console.log("Staff data:", {
            staffName,
            designation,
            rfID,
            departmentName,
            joiningDate,
          });

          return `
            <div class="file-cover-card" style="page-break-after: always; margin-bottom: 30px; max-width: 600px; margin-left: auto; margin-right: auto;">
              <!-- Header with name and date - blue border box -->
              <div class="file-cover-header" style="border: 2px solid #0066cc; border-radius: 8px; padding: 20px; margin-bottom: 60px; display: flex; justify-content: space-between; align-items: center; background: white; box-shadow: 0 2px 4px rgba(0,102,204,0.1); max-width: 900px; margin-left: auto; margin-right: auto;">
                <div style="display: flex; align-items: center;">
                  <div style="width: 16px; height: 16px; background: #0066cc; margin-right: 12px; border-radius: 2px;"></div>
                  <span style="font-weight: bold; font-size: 18px; color: #000; text-transform: uppercase;">${staffName}</span>
                </div>
                <span style="font-weight: bold; font-size: 16px; color: #000;">${joiningDate}</span>
              </div>
              
              <!-- Main content card with double-layered blue border -->
              <div class="file-cover-content" style="border: 3px solid #0066cc; border-radius: 15px; padding: 8px; text-align: center; background: white; position: relative; box-shadow: 0 4px 8px rgba(0,102,204,0.1); max-width: 400px; margin: 0 auto;">
                <!-- Inner double-layered border with same curve -->
                <div style="border: 2px solid #0066cc; border-radius: 12px; padding: 35px 25px; background: white; margin: 0;">
                  <div style="font-weight: bold; font-size: 28px; margin-bottom: 20px; text-transform: uppercase; color: #000; letter-spacing: 1px;">${staffName}</div>
                  <div style="font-weight: bold; font-size: 20px; margin-bottom: 15px; text-transform: uppercase; color: #000; letter-spacing: 0.5px;">(${designation})</div>
                  <div style="font-weight: bold; font-size: 22px; margin-bottom: 15px; color: #000;">ID-${rfID}</div>
                  <div style="font-weight: bold; font-size: 20px; margin-bottom: 0; color: #000; text-transform: uppercase;">${departmentName}</div>
                </div>
              </div>
            </div>
          `;
        })
        .join("");

      // Create the HTML content
      const htmlContent = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>File Cover Report</title>
          <link href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.0/dist/css/bootstrap.min.css" rel="stylesheet">
          <style>
            body { 
              font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; 
              background-color: #f8f9fa; 
              margin: 0; 
              padding: 20px; 
            }
            .file-cover-container { 
              background: white; 
              border-radius: 8px; 
              box-shadow: 0 2px 10px rgba(0,0,0,0.1); 
              overflow: hidden; 
            }
            .file-cover-card {
              page-break-after: always;
              margin-bottom: 30px;
              max-width: 600px;
              margin-left: auto;
              margin-right: auto;
            }
            .file-cover-header {
              border: 2px solid #0066cc;
              border-radius: 8px;
              padding: 20px;
              margin-bottom: 60px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              background: white;
              box-shadow: 0 2px 4px rgba(0,102,204,0.1);
              max-width: 900px;
              margin-left: auto;
              margin-right: auto;
            }
            .file-cover-content {
              border: 3px solid #0066cc;
              border-radius: 15px;
              padding: 8px;
              text-align: center;
              background: white;
              position: relative;
              box-shadow: 0 4px 8px rgba(0,102,204,0.1);
              max-width: 400px;
              margin: 0 auto;
            }
            .file-cover-content::before {
              border: 2px solid #0066cc;
            }
            .print-controls { 
              position: fixed; 
              top: 20px; 
              right: 20px; 
              z-index: 1000; 
            }
            .print-btn { 
              background: linear-gradient(135deg, #28a745 0%, #20c997 100%); 
              color: white; 
              border: none; 
              padding: 10px 20px; 
              border-radius: 6px; 
              cursor: pointer; 
              font-weight: 600; 
              box-shadow: 0 2px 8px rgba(0,0,0,0.15); 
            }
            .print-btn:hover { 
              transform: translateY(-1px); 
              box-shadow: 0 4px 12px rgba(0,0,0,0.2); 
            }
            @media print {
              body { 
                background: white; 
                padding: 0; 
                margin: 0; 
              }
              .print-controls { 
                display: none; 
              }
              .file-cover-card {
                page-break-after: always;
                margin: 0;
                max-width: none;
              }
              .file-cover-header {
                border: 3px solid #0066cc;
              }
              .file-cover-content::before {
                border: 2px solid #0066cc;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-controls">
            <button class="print-btn" onclick="window.print()">🖨️ Print File Covers</button>
          </div>
          
          <div class="file-cover-container">
            ${fileCoverCards}
          </div>
        </body>
        </html>
      `;

      // Open in new tab
      const newTab = window.open("", "_blank");
      newTab.document.write(htmlContent);
      newTab.document.close();
    },
    formatDate(dateString) {
      if (!dateString || dateString === "undefined" || dateString === "null")
        return "N/A";

      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "N/A";

        return date.toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });
      } catch (error) {
        console.error("Error formatting date:", dateString, error);
        return "N/A";
      }
    },
    printByDep() {
      if (this.CheckDepartment() == true) {
        this.printing = true;

        if (
          this.reportDomain === "myskoolsmarthf" &&
          this.$store.state.userData.cId == 2
        ) {
          const depList = Array.isArray(this.cardObj.depList)
            ? this.cardObj.depList
            : [this.cardObj.depList];
          const routeData = this.$router.resolve({
            name: "smart-hassan-staff-id-card",
            query: {
              depID: depList.join(","),
              cID: String(this.$store.state.userData.cId),
              db: this.$store.state.userData.db,
            },
          });
          window.open(routeData.href, "_blank", "noopener,noreferrer");
          this.printing = false;
          this.$bvModal.hide("modal-cards");
          return;
        }

        // Kent / Speak & Spell — Vue staff ID card
        if (isCampusBrandedStaffIdCardDomain(this.reportDomain)) {
          const depList = Array.isArray(this.cardObj.depList)
            ? this.cardObj.depList
            : [this.cardObj.depList];
          this.$router.push({
            name: "kent-staff-id-card",
            query: {
              depID: depList.join(","),
              cID: String(this.$store.state.userData.cId),
              db: this.$store.state.userData.db,
              status: this.currentStatus,
            },
          });
          this.printing = false;
          this.$bvModal.hide("modal-cards");
          return;
        }

        var url =
          `https://${this.reportDomain}.myskool.app/Certificate/StaffCard?dbb=` +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&staffID=0&depID=" +
          this.cardObj.depList;
        window.open(url, "_blank");
        this.printing = false;
        this.$bvModal.hide("modal-cards");
      }
    },
    setRepDep() {
      if (this.repObj.depList.at(-1) == 0) {
        this.repObj.depList = [0];
      } else {
        this.repObj.depList = this.repObj.depList.filter((el) => el != 0);
      }
    },
    openReport() {
      this.$bvModal.show("modal-report");
    },
    printReport(val) {
      // console.log(this.repObj);

      const elem = this.$refs.rep_dep;
      if (
        this.persistentSelectedIds.length == 0 &&
        this.repObj.depList.length == 0
      ) {
        if (elem) elem.state = false;
        return;
      }
      if (elem) elem.state = true;

      const elem2 = this.$refs.rep_session;
      if (this.repObj.sessionID == 0) {
        if (elem2) elem2.state = false;
        return;
      }
      if (elem2) elem2.state = true;

      this.repExporting = val;

      let controller = "Staff";
      if (val) controller = "StaffExport";

      const url =
        `https://${this.reportDomain}.myskool.app/List/${controller}?type=subject-list&dbb=` +
        this.$store.state.userData.db +
        "&cID=" +
        this.$store.state.userData.cId +
        "&depIDs=" +
        this.repObj.depList +
        "&tIDs=" +
        this.persistentSelectedIds +
        "&sessionID=" +
        this.repObj.sessionID +
        "&status=" +
        this.repObj.status +
        "&format=" +
        this.repObj.format;

      if (val) {
        axios
          .get(url)
          .then((response) => {
            // console.log(response.data.data);
            window.open(response.data.data, "_blank");
          })
          .catch((error) => {
            // Handle errors here
            console.error("There was an error!", error);
          })
          .finally(() => {
            this.repExporting = false;
          });
      } else {
        window.open(url, "_blank");
      }
    },
    CheckDepartment() {
      var elem = this.$refs["card_dep"];
      if (this.cardObj.depList.length == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    setDep() {
      if (this.cardObj.depList.at(-1) == 0) {
        this.cardObj.depList = [0];
      } else {
        this.cardObj.depList = this.cardObj.depList.filter((el) => el != 0);
      }
      // console.log(this.cardObj.depList);
    },

    async exportData() {
      this.exporting = true;

      try {
        let dataArray = [];

        // Check if specific staff are selected
        if (this.persistentSelectedIds.length > 0) {
          // Export only selected staff data using LoadDataSelected API
          console.log("Exporting selected staff:", this.persistentSelectedIds);

          // Call the LoadDataSelected API with comma-separated staff IDs
          const baseUrl = `${this.$store.state.domain}Staff/LoadDataSelected`;
          const urlParams = new URLSearchParams({
            db: this.$store.state.userData.db,
            cID: (this.reportDomain == 'myskoolhpgs' && this.$store.state.userData.cId == 1) ? this.filter.cID : this.$store.state.userData.cId,
            tIDs: this.persistentSelectedIds.join(","), // Pass comma-separated staff IDs
          });
          const apiUrl = `${baseUrl}?${urlParams.toString()}`;

          const response = await this.get({
            url: apiUrl,
            token: this.$store.state.userData.token,
          });

          // Handle the API response
          if (response && response.data && Array.isArray(response.data)) {
            dataArray = response.data;
          } else if (Array.isArray(response)) {
            dataArray = response;
          } else {
            this.$bvToast.toast(
              "No data received from server for selected staff",
              {
                title: "Warning",
                variant: "warning",
                toaster: "b-toaster-top-center",
              }
            );
            return;
          }

          if (dataArray.length === 0) {
            this.$bvToast.toast("No selected staff data found to export", {
              title: "Warning",
              variant: "warning",
              toaster: "b-toaster-top-center",
            });
            return;
          }

          console.log(
            "Data received from LoadDataSelected API:",
            dataArray.length,
            "records"
          );
        } else {
          // Export all filtered data (existing behavior)
          console.log("Exporting all filtered staff data");

          // Call the API to get fresh data for export - increase pageSize to get all records
          const baseUrl = `${this.$store.state.domain}staff/LoadDataPagination`;
          const urlParams = new URLSearchParams({
            db: this.$store.state.userData.db,
            cId: (this.reportDomain == 'myskoolhpgs' && this.$store.state.userData.cId == 1) ? this.filter.cID : this.$store.state.userData.cId,
            dptID: this.filter.dep,
            status: this.currentStatus,
            depname: "",
            page: 1,
            applicantStatus: "",
            appointedFrom: this.filter.appointedFrom || "",
            appointedTo: this.filter.appointedTo || "",
            leavingFrom: this.filter.leavingFrom || "",
            leavingTo: this.filter.leavingTo || "",
            designation: this.filter.designation || "",
            gender: this.filter.gender || "",
            sortBy: this.sortBy,
            sortOrder: this.sortOrder,
            pageSize: 10000, // Increased to handle large datasets
          });
          const apiUrl = `${baseUrl}?${urlParams.toString()}`;

          const response = await this.get({
            url: apiUrl,
            token: this.$store.state.userData.token,
          });

          // Handle the API response
          if (response && response.data && Array.isArray(response.data)) {
            dataArray = response.data;
          } else if (Array.isArray(response)) {
            dataArray = response;
          }
        }

        const expData = dataArray.map((item) => {
          const row = {
            empCodeStr: item.empCodeStr,
            name: item.name,
            father_name: item.father_name,
            spouse: item.spouse,
            designation: item.designation,
            department_name: item.department ? item.department.name : "",
            gender: item.gender,
            contact_number: item.contact_number,
            cnic: item.cnic,
            rfID: item.rfID,
            date_of_birth: item.date_of_birth,
            appointedOn: item.appointedOn,
            status: item.status,
            applicantStatus: item.applicantStatus,
            basicSalary: item.basicSalary,
            bonuses: item.bonuses,
            totalSalary: item.totalSalary,
            payMode: item.payMode,
            accountTitle: item.accountTitle,
            accountNumber: item.accountNumber,
            allowedLeaves: item.allowedLeaves,
            remaining_leaves: item.remaining_leaves,
            remaining_sickLeaves: item.remaining_sickLeaves,
            qualification: item.qualification,
            experience: item.experience,
            teachingLevel: item.teachingLevel,
            address_current: item.address_current,
            address_permanent: item.address_permanent,
            emergency_contact_person: item.emergency_contact_person,
            emergency_contact_relation: item.emergency_contact_relation,
            emergency_number: item.emergency_number,
            leaving_date: item.leaving_date,
            rejoining_date: item.rejoining_date,
            registrationDate: item.registrationDate,
            approvalDate: item.approvalDate,
            card_number: item.card_number,
            note: item.note,
          };
          return row;
        });

        const stamp = new Date().toISOString().slice(0, 10);
        const worksheet = buildFormattedWorksheet(expData, {
          columns: STAFF_EXPORT_COLUMNS,
          title: this.$t("Staff"),
          subtitle: `${this.$t("Exported")} ${stamp}`,
        });

        const filename =
          this.persistentSelectedIds.length > 0
            ? `staff-selected-${this.persistentSelectedIds.length}-${stamp}.xlsx`
            : `staff-${stamp}.xlsx`;

        await writeWorkbookToFile(worksheet, filename, "Staff");

        // Show success message
        const message =
          this.persistentSelectedIds.length > 0
            ? `Successfully exported ${this.persistentSelectedIds.length} selected staff records`
            : "Successfully exported all staff data";

        this.$bvToast.toast(message, {
          title: this.$t("Success"),
          variant: "success",
          toaster: "b-toaster-top-center",
        });
      } catch (error) {
        console.error("Export error:", error);
        this.$bvToast.toast("Failed to export data", {
          title: this.$t("Error"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.exporting = false;
      }
    },

    async Filter() {
      // console.log(this.filter);
      this.$bvModal.hide("modal-login");
      this.dataLoading = true;
      let myitem = await this.get({
        url:
          this.$store.state.domain +
          "staff/filter?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId +
          "&dptID=" +
          this.filter.dep +
          "&status=" +
          this.filter.status +
          "&appointedFrom=" +
          (this.filter.appointedFrom || "") +
          "&appointedTo=" +
          (this.filter.appointedTo || "") +
          "&designation=" +
          encodeURIComponent(this.filter.designation || "") +
          "&gender=" +
          encodeURIComponent(this.filter.gender || ""),
        token: this.$store.state.userData.token,
      });
      this.items = myitem;
      if (this.items.length != 0) {
        this.totalRows = this.items.length;
      }
      this.currentStatus = this.filter.status;
      this.dataLoading = false;
    },
    OpenImport() {
      this.visibility = true;
    },
    async ImportStaff() {
      this.staffImporting = true;
      const schema = {
        id: {
          prop: "id",
          type: Number,
        },
        rfID: {
          prop: "rfID",
          type: String,
        },
        name: {
          prop: "name",
          type: String,
        },
        father_name: {
          prop: "father_name",
          type: String,
        },
        designation: {
          prop: "designation",
          type: String,
        },
        gender: {
          prop: "gender",
          type: String,
        },
        picture: {
          prop: "picture",
          type: String,
        },
        date_of_birth: {
          prop: "date_of_birth",
          type: Date,
        },
        address_current: {
          prop: "address_current",
          type: String,
        },
        address_permanent: {
          prop: "address_permanent",
          type: String,
        },
        contact_number: {
          prop: "contact_number",
          type: String,
        },
        emergency_contact_person: {
          prop: "emergency_contact_person",
          type: String,
        },
        emergency_contact_relation: {
          prop: "emergency_contact_relation",
          type: String,
        },
        emergency_number: {
          prop: "emergency_number",
          type: String,
        },
        qualification: {
          prop: "qualification",
          type: String,
        },
        experience: {
          prop: "experience",
          type: String,
        },
        campusID: {
          prop: "campusID",
          type: Number,
        },
        canPostNewsFeed: {
          prop: "canPostNewsFeed",
          type: Boolean,
        },
        totalPeriods: {
          prop: "totalPeriods",
          type: Number,
        },
        status: {
          prop: "status",
          type: String,
        },
        deviceID: {
          prop: "deviceID",
          type: String,
        },
        departmentID: {
          prop: "departmentID",
          type: Number,
        },
        availibility: {
          prop: "availibility",
          type: String,
        },
        documents: {
          prop: "documents",
          type: String,
        },
        expectedSalary: {
          prop: "expectedSalary",
          type: Number,
        },
        appointedOn: {
          prop: "appointedOn",
          type: Date,
        },
        basicSalary: {
          prop: "basicSalary",
          type: Number,
        },
        bonuses: {
          prop: "bonuses",
          type: Number,
        },
        totalSalary: {
          prop: "totalSalary",
          type: Number,
        },
        note: {
          prop: "note",
          type: String,
        },
        allowedLeaves: {
          prop: "allowedLeaves",
          type: Number,
        },
        joinsAt: {
          prop: "joinsAt",
          type: Date,
        },
        accountTitle: {
          prop: "accountTitle",
          type: String,
        },
        accountNumber: {
          prop: "accountNumber",
          type: String,
        },
        payMode: {
          prop: "payMode",
          type: String,
        },
        joinsAt: {
          prop: "leaving_date",
          type: Date,
        },
        department: {
          prop: "department",
          type: String,
        },
        cnic: {
          prop: "cnic",
          type: String,
        },
        leaves_allowed_from: {
          prop: "leaves_allowed_from",
          type: Date,
        },
      };
      // console.log("import staff....");
      const input = document.getElementById("importStaff");
      // console.log(input.files);
      await readXlsxFile(input.files[0], { schema })
        .then((rows) => {
          // `rows` is an array of rows
          this.staffData = rows.rows;
        })
        .catch((err) => {
          console.log(err);
          this.staffImporting = false;
        });
      // console.log(this.staffData);
      const chunkSize = 10000;
      let chunkLength = 0;

      for (let i = 0; i < this.staffData.length; i += chunkSize) {
        const chunk = this.staffData.slice(i, i + chunkSize);
        chunkLength += chunk.length;

        // console.log(chunk);
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Staff/SaveAll?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&userID=" +
            this.$store.state.userData.userID,
          body: chunk,
          message: this.$t("Staff data imported."),
          importing: true,
          lastChunk: chunkLength == this.staffData.length,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (!status) this.staffImporting = false;
        else if (chunkLength == this.staffData.length)
          this.staffImporting = false;
      }
    },
    Edit(id) {
      // Check if user has single page right
      const hasStaffAccountsRight = this.rights.singlePage;

      // Route to manage-staff-accounts if right exists, otherwise use default manage-staff
      const routeName = hasStaffAccountsRight
        ? "manage-staff-accounts"
        : "manage-staff";

      this.$router.push({
        name: routeName,
        params: {
          id: id,
        },
      });
    },
    Perf(id) {
      this.$router.push({
        name: "staff-evaluation",
        params: {
          id: id,
        },
      });
    },
    openClasses(id) {
      this.$router.push({
        name: "teaching-classes",
        params: {
          id: id,
        },
      });
    },
    timeTable(id) {
      this.$router.push({
        name: "timetable",
        params: {
          id: id,
        },
      });
    },
    openPlanner(id) {
      this.$router.push({
        name: "manage-planner",
        params: {
          id: id,
        },
      });
    },
    AddOpen() {
      // Check if user has single page right
      const hasStaffAccountsRight = this.rights.singlePage;

      // Route to manage-staff-accounts if right exists, otherwise use default manage-staff
      const routeName = hasStaffAccountsRight
        ? "manage-staff-accounts"
        : "manage-staff";

      this.$router.push({
        name: routeName,
        params: {
          id: 0,
        },
      });
    },
    openLeft(item) {
      this.myObj = {
        ...item,
        leavingCategory: "",
        leavingReason: "",
      };
      this.leavingReasonOther = "";
      this.visibility2 = true;
    },
    onLeavingCategoryChange() {
      this.myObj.leavingReason = "";
      this.leavingReasonOther = "";
    },
    onLeavingReasonChange() {
      if (!this.isOtherLeavingReason) {
        this.leavingReasonOther = "";
      }
    },
    normalizeStaffDateField(value) {
      if (value == null) return null;
      const raw = String(value).trim();
      if (!raw) return null;
      if (raw.startsWith("0001-01-01")) return null;
      if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
        const year = Number(raw.slice(0, 4));
        return Number.isFinite(year) && year >= 1900 ? raw : null;
      }
      const parsed = new Date(raw);
      if (Number.isNaN(parsed.getTime()) || parsed.getFullYear() < 1900) {
        return null;
      }
      return parsed.toISOString().slice(0, 10);
    },
    prepareStaffUpdateBody(source) {
      const body = JSON.parse(JSON.stringify(source || {}));
      const dateKeys = [
        "leaving_date",
        "rejoining_date",
        "date_of_birth",
        "appointedOn",
        "registrationDate",
        "approvalDate",
        "joinsAt",
        "leaves_allowed_from",
      ];
      dateKeys.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(body, key)) {
          body[key] = this.normalizeStaffDateField(body[key]);
        }
      });
      return body;
    },
    checkLeftDate() {
      var elem = this.$refs["left_date"];
      const leavingDate = this.normalizeStaffDateField(this.myObj.leaving_date);
      if (!leavingDate) {
        return (elem.state = false);
      }
      if (leavingDate !== this.myObj.leaving_date) {
        this.myObj.leaving_date = leavingDate;
      }
      return (elem.state = true);
    },
    resolveLeavingReasonForApi() {
      if (this.usesStructuredLeavingReasons && this.isOtherLeavingReason) {
        const custom = (this.leavingReasonOther || "").trim();
        // Keep "Other (Specify)" + custom text so view can show both clearly
        return custom
          ? `Other (Specify): ${custom}`
          : "Other (Specify)";
      }
      return this.myObj.leavingReason || "";
    },
    async markLeft() {
      if (this.checkLeftDate() == true) {
        this.saving = true;
        this.myObj.status = "left";

        // Prepare MarkLeft API query parameters
        const queryParams = new URLSearchParams({
          db: this.$store.state.userData.db,
          tID: this.myObj.id,
          leaving_date: this.normalizeStaffDateField(this.myObj.leaving_date),
          leavingCategory: this.myObj.leavingCategory || "",
          leavingReason: this.resolveLeavingReasonForApi(),
          userID: this.$store.state.userData.userID,
        });

        var status = await this.post({
          url:
            this.$store.state.domain +
            "staff/MarkLeft?" +
            queryParams.toString(),
          body: null,
          message: this.$t("Staff marked as left successfully!"),
          context: this,
          token: this.$store.state.userData.token,
        });
        this.saving = false;
        if (status) {
          this.visibility2 = false;
          this.LoadData();
        }
      }
    },
    openReadmit(item) {
      this.myObj = { ...item };
      this.visibility3 = true;
    },
    checkReDate() {
      var elem = this.$refs["readmit_date"];
      const rejoinDate = this.normalizeStaffDateField(this.myObj.rejoining_date);
      if (!rejoinDate) {
        return (elem.state = false);
      }
      if (rejoinDate !== this.myObj.rejoining_date) {
        this.myObj.rejoining_date = rejoinDate;
      }
      return (elem.state = true);
    },
    async markReadmit(val) {
      // no need to check on rejoin
      const check = val ? val : this.checkReDate();

      if (check) {
        if (val) {
          this.savingRej = true;
        } else {
          this.saving = true;
        }
        this.myObj.status = "present";

        var res = await this.put({
          url:
            this.$store.state.domain +
            "staff/Update?db=" +
            this.$store.state.userData.db +
            "&userID=" +
            this.$store.state.userData.userID,
          body: this.prepareStaffUpdateBody(this.myObj),
          message: this.$t("Staff readmitted successfully!"),
          context: this,
          token: this.$store.state.userData.token,
        });
        this.saving = false;
        this.savingRej = false;
        if (res) {
          this.visibility3 = false;
          this.LoadData();
        }
      }
    },
    async changeStatus(item, st) {
      let text = "";
      let message = "";
      if (st == "present") {
        text = "This will readmit the staff.";
        message = "Staff readmitted succesfully!";
      } else {
        text = "This will mark staff as left.";
        message = "Staff marked as left successfully!";
      }
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes"),
      });
      if (result.isConfirmed) {
        item.status = st;

        if (st === "left") {
          // Use MarkLeft API for left status
          const queryParams = new URLSearchParams({
            db: this.$store.state.userData.db,
            tID: item.id,
            leaving_date:
              this.normalizeStaffDateField(item.leaving_date) ||
              new Date().toISOString().split("T")[0],
            leavingCategory: item.leavingCategory || "",
            userID: this.$store.state.userData.userID,
          });

          var res = await this.post({
            url:
              this.$store.state.domain +
              "staff/MarkLeft?" +
              queryParams.toString(),
            body: null,
            message: this.$t(message),
            context: this,
            token: this.$store.state.userData.token,
          });
          if (res) {
            this.LoadData();
          }
        } else {
          // Use regular PUT for other status changes
          var res = await this.put({
            url:
              this.$store.state.domain +
              "staff/Update?db=" +
              this.$store.state.userData.db +
              "&userID=" +
              this.$store.state.userData.userID,
            body: this.prepareStaffUpdateBody(item),
            message: this.$t(message),
            context: this,
            token: this.$store.state.userData.token,
          });
          if (res) {
            this.LoadData();
          }
        }
      }
    },
    async Delete(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "staff/Delete?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&id=" +
            id +
            "&userID=" +
            this.$store.state.userData.userID,
          message: this.$t("Staff deleted successfully."),
          context: this,
          body: null,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadData();
      }
      // Swal.fire({
      //   title: 'Are you sure?',
      //   text: this.$t("You won't be able to revert this!"),
      //   icon: 'warning',
      //   showCancelButton: true,
      //   confirmButtonColor: '#3085d6',
      //   cancelButtonColor: '#d33',
      //   confirmButtonText: 'Yes, Delete it!',
      // }).then(result => {
      //   if (result.isConfirmed) {

      //   }
      // });
    },
    async loadSettings() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: ["show_salary", "faceID"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      this.showSalary = res.find((el) => el.key == "show_salary");
      const faceIdSetting = res.find(
        (el) => el.key == "faceID" && el.value == "true"
      );
      this.showFaceId = faceIdSetting?.valueBool || false;
    },
    async LoadSettingsAll() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettingsAll?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: ["class_teacher_attd", "staff_request", "template_link"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      this.ctObj = res.find((el) => el.key == "class_teacher_attd");
      this.slrObj = res.find((el) => el.key == "staff_request");
      this.templateLink = res.find((el) => el.key == "template_link");
      // console.log(this.slrObj);
    },
    async LoadSessions() {
      let res = await this.get({
        url:
          this.$store.state.domain +
          "Sessions?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      });
      this.sessionOptions = res;
      let obj = this.sessionOptions.find((el) => el.isCurrentSession == true);
      if (!obj) this.repObj.sessionID = 0;
      else this.repObj.sessionID = obj.id;
    },
    normalizeItems(items) {
      if (!Array.isArray(items)) return [];
      return items.map((item) => {
        return {
          ...item,
          metaCampusName:
            item.metaCampusName ||
            item.campus ||
            item.campusName ||
            this.getCampus(item.campusID),
        };
      });
    },

    async LoadDep() {
      var obj = {
        url:
          this.$store.state.domain +
          "StaffDepartments?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      const result = await this.get(obj);
      const list = Array.isArray(result)
        ? result
        : Array.isArray(result?.data)
        ? result.data
        : [];
      // Normalize IDs so v-select can match selected value reliably
      this.departments = list.map((dep) => ({
        ...dep,
        id: Number(dep.id),
        name: dep.name,
      }));
    },

    async LoadData(text) {
      //  this.items =[];
      this.dataLoading = true;
      // let myitem = await this.get({
      //   url:
      //     this.$store.state.domain +
      //     "staff/filter?db=" +
      //     this.$store.state.userData.db +
      //     "&cId=" +
      //     this.$store.state.userData.cId +
      //     "&dptID=0&status=" +
      //     this.currentStatus,
      //   token: this.$store.state.userData.token,
      // });
      if (text == "filter") {
        this.$bvModal.hide("modal-login");
        this.currentPage = 1;
      } else if (text == "dd") {
        this.filter.dep = 0;
        this.currentPage = 1;
      }
      console.log("LoadData - Report Domain:", this.reportDomain);
      console.log("LoadData - Sort By:", this.sortBy);
      console.log("LoadData - Sort Order:", this.sortOrder);

      let myitem = await this.get({
        url:
          this.$store.state.domain +
          "staff/LoadDataPagination?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.filter.cID +
          "&dptID=" +
          this.filter.dep +
          "&status=" +
          this.currentStatus +
          "&page=" +
          this.currentPage +
          "&appointedFrom=" +
          (this.filter.appointedFrom || "") +
          "&appointedTo=" +
          (this.filter.appointedTo || "") +
          "&leavingFrom=" +
          (this.filter.leavingFrom || "") +
          "&leavingTo=" +
          (this.filter.leavingTo || "") +
          "&designation=" +
          encodeURIComponent(this.filter.designation || "") +
          "&gender=" +
          encodeURIComponent(this.filter.gender || "") +
          "&sortBy=" +
          this.sortBy +
          "&sortOrder=" +
          this.sortOrder,
        token: this.$store.state.userData.token,
        dashboard: true,
      });
      // console.log(myitem);
      this.items = this.normalizeItems(myitem.data);
      this.totalCount = myitem.count;

      this.dataLoading = false;
      // console.log("items", this.items);

      let fData = {
        depID: this.filter.dep,
        campID: this.filter.cID,
        page: this.currentPage,
        currentStatus: this.currentStatus,
        total: this.totalCount,
        db: this.$store.state.userData.db,
        cID: this.$store.state.userData.cId,
      };
      let ind = this.filterData.findIndex(
        (el) =>
          el.db == this.$store.state.userData.db &&
          el.cID == this.$store.state.userData.cId
      );
      if (ind != -1) {
        this.filterData[ind] = { ...fData };
      } else {
        this.filterData.push(fData);
      }
      this.$store.commit("setStaffFilter", this.filterData);

      // Restore persistent selections after data is loaded
      this.$nextTick(() => {
        this.restoreSelections();
      });

      // console.log(this.filterData);
    },
    async loadSearch() {
      if (this.searchQuery.trim() == "") {
        this.currentPage = 1;
        this.LoadData();
      } else {
        this.dataLoading = true;

        // Build search URL based on selected criteria
        let searchUrl =
          this.$store.state.domain +
          "staff/Search?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&keyword=" +
          this.searchQuery +
          "&status=" +
          this.currentStatus;

        // Add search criteria parameter if needed
        if (this.selectedSearchCriteria.value !== "") {
          searchUrl += "&searchBy=" + this.selectedSearchCriteria.value;
        }

        console.log(
          "Searching with criteria:",
          this.selectedSearchCriteria.text,
          "Query:",
          this.searchQuery
        );
        console.log("Search URL:", searchUrl);
        console.log(
          "Selected criteria value:",
          this.selectedSearchCriteria.value
        );

        let myitem = await this.get({
          url: searchUrl,
          token: this.$store.state.userData.token,
        });
        this.items = this.normalizeItems(myitem);
        this.totalCount = 0;
        this.currentPage = 1;
        this.dataLoading = false;
      }
    },

    // Search criteria functionality
    selectSearchCriteria(criteria) {
      this.selectedSearchCriteria = criteria;
      // Save to localStorage
      localStorage.setItem("staffSearchCriteria", JSON.stringify(criteria));
      console.log("Selected search criteria:", criteria);
    },

    // Load search criteria from localStorage
    loadSearchCriteriaFromStorage() {
      try {
        const savedCriteria = localStorage.getItem("staffSearchCriteria");
        if (savedCriteria) {
          const criteria = JSON.parse(savedCriteria);
          // Verify the criteria exists in our options
          const validCriteria = this.searchCriteriaOptions.find(
            (option) => option.value === criteria.value
          );
          if (validCriteria) {
            this.selectedSearchCriteria = validCriteria;
            console.log(
              "Loaded search criteria from localStorage:",
              validCriteria
            );
          }
        }
      } catch (error) {
        console.error(
          "Error loading search criteria from localStorage:",
          error
        );
        // Reset to default if there's an error
        this.selectedSearchCriteria = this.searchCriteriaOptions[0];
      }
    },
    async registerFaceId(item) {
      try {
        if (!item.rfID) {
          this.$root.$bvToast.toast("Please define RFID for staff", {
            title: this.$t("Error"),
            variant: "danger",
            solid: true,
          });
          return;
        }

        this.faceIdLoading = true;
        this.currentStaffId = item.id;

        const formattedDomain = this.reportDomain.replace(/_/g, "-");
        const campusId = this.$store.state.userData.cId;
        const baseUrl = `https://${formattedDomain}-${campusId}.cloudious.net/create-enrollment-link?cID=${campusId}`;
        const enrollmentUrl = baseUrl.replace(/^http:/, "https:");

        const response = await fetch(enrollmentUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: item.name,
            id: item.rfID,
          }),
        });

        const data = await response.json();
        this.enrollmentLink = data.enrollmentLink.replace(/^http:/, "https:");
        this.showFaceIdModal = true;

        // Add a small delay to ensure iframe is mounted
        setTimeout(() => {
          const iframe = document.querySelector("iframe");
          if (iframe) {
            iframe.setAttribute("allow", "camera;microphone");
          }
        }, 100);
      } catch (error) {
        console.error("Error registering face ID:", error);
        this.$root.$bvToast.toast("Error registering face ID", {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
      } finally {
        this.faceIdLoading = false;
      }
    },

    copyLink() {
      navigator.clipboard.writeText(this.enrollmentLink);
      this.$bvToast.toast("Link copied to clipboard", {
        title: this.$t("Success"),
        variant: "success",
        solid: true,
      });
    },

    async shareWhatsApp() {
      try {
        const response = await this.post({
          url: `${this.$store.state.domain}Chat/ShareFaceLink?db=${this.$store.state.userData.db}`,
          body: {
            tID: this.currentStaffId,
            link: this.enrollmentLink,
            isTeacher: false,
          },
          token: this.$store.state.userData.token,
          message: this.$t("Link sent on WhatsApp"), // Add this line to use the built-in toast from post method
          context: this,
        });

        if (response) {
          this.showFaceIdModal = false;
        }
      } catch (error) {
        console.error("Error sharing link:", error);
        // Let the post method handle the error toast
      }
    },
    resetToDefault() {
      // Reset to original default visibility
      this.allFields.forEach((field) => {
        if (
          [
            "index",
            "name",
            "contact_number",
            "department",
            "qualification",
            "designation",
            "status",
          ].includes(field.key)
        ) {
          field.visible = true;
        } else if (
          field.key === "campus" &&
          this.reportDomain == "myskoolhpgs"
        ) {
          field.visible = true;
        } else {
          field.visible = false;
        }
      });

      // Also reset filter fields to default
      this.filter.appointedFrom = "";
      this.filter.appointedTo = "";
      this.filter.designation = "";
      this.filter.gender = "";
    },
    selectAll() {
      this.allFields.forEach((field) => (field.visible = true));
    },
    deselectAll() {
      this.allFields.forEach((field) => {
        if (!field.required) {
          field.visible = false;
        }
      });
    },
    openColumnSettings() {
      this.visibilitySettings = true;
      this.loadColumnSettings(); // Load saved settings when opening
    },
    async saveColumnSettings() {
      this.savingSettings = true;
      try {
        // Get only non-default visible fields (exclude required/default fields)
        const nonDefaultFields = this.allFields.filter(
          (field) =>
            !field.required &&
            field.visible &&
            ![
              "index",
              "name",
              "contact_number",
              "department",
              "qualification",
              "designation",
              "status",
            ].includes(field.key)
        );

        // Create the value string with non-default visible fields
        const valueString = nonDefaultFields
          .map((field) => `${field.label}: true`)
          .join(", ");

        // Prepare payload according to specifications
        let obj = {
          id: 0,
          campusID: this.$store.state.userData.cId, // Campus ID correctly passed
          key: "staff-grid",
          value: valueString, // Format: "Experience: true, Confirmation Date: true"
          valueBool: true,
          valueNumber: this.$store.state.userData.userID, // Login user ID saved (fixed property name)
        };
        if (this.userSetting) {
          obj = { ...this.userSetting };
          obj.value = valueString;
        }

        const response = await this.post({
          url: `${this.$store.state.domain}Settings/SaveNew?db=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}`,
          body: [obj],
          context: this,
          importing: true,
          token: this.$store.state.userData.token,
        });

        if (response) {
          this.$bvToast.toast("Column settings saved successfully!", {
            title: "Success!",
            variant: "success",
            toaster: "b-toaster-top-center",
          });
        }
      } catch (error) {
        console.error("Error saving column settings:", error);
        this.$bvToast.toast("Error saving column settings.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
      this.savingSettings = false;
    },
    async loadColumnSettings() {
      try {
        console.log(
          "Loading column settings for user:",
          this.$store.state.userData.userID
        );

        const response = await this.post({
          url: `${this.$store.state.domain}Settings/getSettings?db=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}`,
          body: ["staff-grid"],
          context: this,
          token: this.$store.state.userData.token,
          subjects: true,
        });

        console.log("API Response:", response);
        console.log("Response type:", typeof response);
        console.log(
          "Response keys:",
          response ? Object.keys(response) : "No keys"
        );

        // Handle the response - match existing loadSettings pattern
        let settingsArray;

        if (
          response &&
          response.status === "success" &&
          response.data &&
          Array.isArray(response.data)
        ) {
          console.log(
            "Response has status success and data array:",
            response.data
          );
          settingsArray = response.data;
        } else if (Array.isArray(response)) {
          console.log(
            "Response is array directly (like existing loadSettings):",
            response
          );
          settingsArray = response;
        } else if (response === true || response === false) {
          console.log("Response is boolean, no settings data available");
          settingsArray = [];
        } else {
          console.log("Unexpected response format:", response);
          settingsArray = [];
        }

        if (settingsArray && Array.isArray(settingsArray)) {
          // Find settings for current user
          this.userSetting = settingsArray.find(
            (setting) =>
              setting.valueNumber === this.$store.state.userData.userID &&
              setting.key === "staff-grid"
          );

          console.log("User setting found:", this.userSetting);

          if (this.userSetting && this.userSetting.value) {
            console.log("Processing saved settings...");

            // Debug: Show all available field labels BEFORE processing
            console.log(
              "All available field labels:",
              this.allFields.map((f) => `"${f.label}"`)
            );
            console.log(
              "All field objects:",
              this.allFields.map((f) => ({
                label: f.label,
                key: f.key,
                visible: f.visible,
              }))
            );

            // First, reset ALL non-default fields to false
            this.allFields.forEach((field) => {
              if (
                !field.required &&
                ![
                  "index",
                  "name",
                  "contact_number",
                  "department",
                  "qualification",
                  "designation",
                  "status",
                ].includes(field.key)
              ) {
                field.visible = false;
                console.log(`Reset ${field.label} (${field.key}) to false`);
              }
            });

            // Parse saved settings and apply them
            console.log("Parsing saved value:", this.userSetting.value);
            const savedFields = this.userSetting.value.split(", ");
            console.log("Split fields:", savedFields);

            // Process each saved field
            savedFields.forEach((fieldString, index) => {
              console.log(`Processing field ${index + 1}:`, fieldString);
              if (fieldString.trim().includes(": true")) {
                const fieldLabel = fieldString.replace(": true", "").trim();
                console.log(`Looking for field with label: "${fieldLabel}"`);

                // Find the field by label (case-sensitive exact match)
                const field = this.allFields.find(
                  (f) => f.label === fieldLabel
                );
                if (field) {
                  console.log(`Found field:`, field);
                  console.log(
                    `Before setting: ${field.label} visible = ${field.visible}`
                  );

                  // Use Vue.set to ensure reactivity
                  this.$set(field, "visible", true);

                  console.log(
                    `After setting: ${field.label} visible = ${field.visible}`
                  );
                  console.log(
                    `✅ Set "${fieldLabel}" to visible (${field.visible})`
                  );
                } else {
                  console.log(`❌ Field not found for label: "${fieldLabel}"`);

                  // Debug: Try case-insensitive search
                  const caseInsensitiveField = this.allFields.find(
                    (f) => f.label.toLowerCase() === fieldLabel.toLowerCase()
                  );
                  if (caseInsensitiveField) {
                    console.log(
                      `Found case-insensitive match:`,
                      caseInsensitiveField
                    );
                    console.log(
                      `Before setting: ${caseInsensitiveField.label} visible = ${caseInsensitiveField.visible}`
                    );

                    // Use Vue.set to ensure reactivity
                    this.$set(caseInsensitiveField, "visible", true);

                    console.log(
                      `After setting: ${caseInsensitiveField.label} visible = ${caseInsensitiveField.visible}`
                    );
                    console.log(
                      `✅ Set "${caseInsensitiveField.label}" to visible (case-insensitive)`
                    );
                  } else {
                    // Show similar fields for debugging
                    const similarFields = this.allFields.filter(
                      (f) =>
                        f.label
                          .toLowerCase()
                          .includes(fieldLabel.toLowerCase()) ||
                        fieldLabel.toLowerCase().includes(f.label.toLowerCase())
                    );
                    console.log(
                      "Similar fields found:",
                      similarFields.map((f) => `"${f.label}"`)
                    );
                  }
                }
              }
            });

            // Force Vue to update the DOM
            this.$nextTick(() => {
              this.$forceUpdate();

              // Final verification - check what's actually visible now
              const visibleFields = this.allFields.filter(
                (field) => field.visible
              );
              console.log(
                "All visible fields after update:",
                visibleFields.map((f) => `${f.label}: ${f.visible}`)
              );

              const nonDefaultVisible = this.allFields.filter(
                (field) =>
                  !field.required &&
                  field.visible &&
                  ![
                    "index",
                    "name",
                    "contact_number",
                    "department",
                    "qualification",
                    "designation",
                    "status",
                  ].includes(field.key)
              );
              console.log(
                "Non-default fields now visible:",
                nonDefaultVisible.map((f) => f.label)
              );
            });

            // Don't show toast since this runs automatically on load
            // this.$bvToast.toast("Column settings loaded successfully!", {
            //   title: "Success!",
            //   variant: "success",
            //   toaster: "b-toaster-top-center",
            // });
          } else {
            console.log(
              "No saved column settings found for user:",
              this.$store.state.userData.userID
            );
            console.log(
              "This might be the first time opening column settings."
            );
            // this.$bvToast.toast("No previous column settings found. Default columns are displayed.", {
            //   title: "Info",
            //   variant: "info",
            //   toaster: "b-toaster-top-center",
            // });
          }
        } else {
          console.log("Invalid response format:", response);
        }
      } catch (error) {
        console.error("Error loading column settings:", error);
        this.$bvToast.toast("Error loading column settings.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
    },
    resetFilters() {
      this.filter.dep = 0;
      this.filter.status = "present";
      this.filter.appointedFrom = "";
      this.filter.appointedTo = "";
      this.filter.leavingFrom = "";
      this.filter.leavingTo = "";
      this.filter.designation = "";
      this.filter.gender = "";
      this.currentStatus = "present"; // Reset to default status
      this.LoadData();
    },
    // Sorting methods
    handleSort(key) {
      if (this.sortBy === key) {
        // Toggle sort order if same column
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        // New column, set to ascending
        this.sortBy = key;
        this.sortOrder = "asc";
      }

      // Reload data with new sorting
      this.LoadData();
    },
    addDesignation() {
      this.submitDesignationForm();
    },
    submitDesignationForm() {
      if (this.editingDesignationIndex > -1) {
        this.saveEditedDesignation();
        return;
      }

      const name = (this.newDesignation || "").trim();
      const departmentID = Number(this.newDesignationDepartmentID) || 0;

      if (!name) return;

      if (!departmentID) {
        this.$bvToast.toast("Please select a department first.", {
          title: "Warning!",
          variant: "warning",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      const exists = this.designations.some(
        (item) =>
          String(item.name || "")
            .trim()
            .toLowerCase() === name.toLowerCase() &&
          Number(item.departmentID) === departmentID
      );

      if (exists) {
        this.$bvToast.toast(
          "Designation already exists for this department!",
          {
            title: "Warning!",
            variant: "warning",
            toaster: "b-toaster-top-center",
          }
        );
        return;
      }

      this.designations.push({ name, departmentID });
      this.newDesignation = "";
      // Persist immediately
      this.saveDesignationSettings({ keepOpen: true, silent: false });
    },
    async startEditDesignation(index) {
      const item = this.designations[index];
      if (!item) return;

      // Make sure departments are loaded so selected value shows
      if (!this.departments || this.departments.length === 0) {
        await this.LoadDep();
      }

      this.editingDesignationIndex = index;
      this.newDesignation = item.name || "";
      const depId = Number(item.departmentID) || 0;
      this.$nextTick(() => {
        this.newDesignationDepartmentID = depId > 0 ? depId : null;
      });
    },
    cancelEditDesignation() {
      this.editingDesignationIndex = -1;
      this.newDesignation = "";
      this.newDesignationDepartmentID = null;
    },
    async saveEditedDesignation() {
      const index = this.editingDesignationIndex;
      if (index < 0 || !this.designations[index]) return;

      const name = (this.newDesignation || "").trim();
      const departmentID = Number(this.newDesignationDepartmentID) || 0;

      if (!name) {
        this.$bvToast.toast("Please enter designation name.", {
          title: "Warning!",
          variant: "warning",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      if (!departmentID) {
        this.$bvToast.toast("Please select a department.", {
          title: "Warning!",
          variant: "warning",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      const exists = this.designations.some(
        (item, i) =>
          i !== index &&
          String(item.name || "")
            .trim()
            .toLowerCase() === name.toLowerCase() &&
          Number(item.departmentID) === departmentID
      );

      if (exists) {
        this.$bvToast.toast(
          "Designation already exists for this department!",
          {
            title: "Warning!",
            variant: "warning",
            toaster: "b-toaster-top-center",
          }
        );
        return;
      }

      this.$set(this.designations, index, { name, departmentID });
      this.cancelEditDesignation();
      // Persist immediately so department-wise filter works
      await this.saveDesignationSettings({ keepOpen: true, silent: false });
    },
    async removeDesignation(index) {
      if (this.editingDesignationIndex === index) {
        this.cancelEditDesignation();
      } else if (this.editingDesignationIndex > index) {
        this.editingDesignationIndex -= 1;
      }
      this.designations.splice(index, 1);
      await this.saveDesignationSettings({ keepOpen: true, silent: true });
    },
    onDesignationSidebarHidden() {
      this.cancelEditDesignation();
      this.setFocus();
    },
    getDesignationNamesForDepartment(departmentID) {
      const depId = Number(departmentID) || 0;
      return (this.designations || [])
        .filter((item) => {
          const itemDepId = Number(item.departmentID) || 0;
          if (!depId) return true;
          return itemDepId === depId || itemDepId === 0;
        })
        .map((item) => item.name)
        .filter((name) => !!name);
    },
    normalizeDesignations(rawValue) {
      if (!rawValue) return [];

      if (typeof rawValue === "string" && rawValue.trim().startsWith("[")) {
        try {
          const parsed = JSON.parse(rawValue);
          if (Array.isArray(parsed)) {
            return parsed
              .map((item) => {
                if (typeof item === "string") {
                  return { name: item.trim(), departmentID: 0 };
                }
                return {
                  name: String(item.name || "").trim(),
                  departmentID: Number(item.departmentID) || 0,
                };
              })
              .filter((item) => item.name);
          }
        } catch (e) {
          // fall through
        }
      }

      if (typeof rawValue === "string") {
        return rawValue
          .split(",")
          .map((name) => name.trim())
          .filter((name) => name)
          .map((name) => ({ name, departmentID: 0 }));
      }

      if (Array.isArray(rawValue)) {
        return rawValue
          .map((item) => {
            if (typeof item === "string") {
              return { name: item.trim(), departmentID: 0 };
            }
            return {
              name: String(item.name || "").trim(),
              departmentID: Number(item.departmentID) || 0,
            };
          })
          .filter((item) => item.name);
      }

      return [];
    },
    openDesignationSettings() {
      this.cancelEditDesignation();
      this.visibilityDesignation = true;

      // Load departments for dropdown (awaited in edit as well)
      this.LoadDep();

      // Always refresh designations when opening so latest saved data is used
      this.loadDesignationSettings(true);
    },
    async saveDesignationSettings(options = {}) {
      const keepOpen = options.keepOpen === true;
      const silent = options.silent === true;

      if (this.savingDesignation) return;
      this.savingDesignation = true;
      try {
        const valueString = JSON.stringify(
          (this.designations || []).map((item) => ({
            name: item.name,
            departmentID: Number(item.departmentID) || 0,
          }))
        );

        let obj = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          key: "staff-designations",
          value: valueString,
          valueBool: true,
          valueNumber: this.$store.state.userData.userID,
        };

        if (this.designationSetting) {
          obj = { ...this.designationSetting };
          obj.value = valueString;
          obj.campusID = this.designationSetting.campusID || obj.campusID;
        }

        const response = await this.post({
          url: `${this.$store.state.domain}Settings/SaveNew?db=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}`,
          body: [obj],
          context: this,
          token: this.$store.state.userData.token,
          subjects: true,
        });

        if (response) {
          if (this.designationSetting) {
            this.designationSetting.value = valueString;
          } else if (response.data && Array.isArray(response.data)) {
            this.designationSetting =
              response.data.find((s) => s.key === "staff-designations") || {
                ...obj,
              };
          } else if (response === true || typeof response === "object") {
            this.designationSetting = { ...obj };
          } else {
            this.designationSetting = { ...obj };
          }
          this.designationsLoaded = true;
          this.showDesignationSettings = true;
          this.cancelEditDesignation();

          if (!silent) {
            this.$bvToast.toast("Designations saved successfully!", {
              title: "Success!",
              variant: "success",
              toaster: "b-toaster-top-center",
            });
          }

          if (!keepOpen) {
            this.visibilityDesignation = false;
          }
        }
      } catch (error) {
        console.error("Error saving designation settings:", error);
        this.$bvToast.toast("Error saving designation settings.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.savingDesignation = false;
      }
    },
    async loadDesignationSettings(force = false) {
      if (this.loadingDesignationSettings) return;
      if (this.designationsLoaded && !force) return;

      this.loadingDesignationSettings = true;
      try {
        const response = await this.post({
          url: `${this.$store.state.domain}Settings/getSettingsAll?db=${this.$store.state.userData.db}`,
          body: ["staff-designations"],
          context: this,
          token: this.$store.state.userData.token,
          subjects: true,
        });

        let settingsArray = [];
        if (
          response &&
          response.status === "success" &&
          response.data &&
          Array.isArray(response.data)
        ) {
          settingsArray = response.data;
        } else if (Array.isArray(response)) {
          settingsArray = response;
        }

        this.designationSetting =
          settingsArray.find(
            (setting) =>
              setting.key === "staff-designations" &&
              Number(setting.campusID) === Number(this.$store.state.userData.cId)
          ) ||
          settingsArray.find((setting) => setting.key === "staff-designations");

        // Only show icon when staff-designations setting exists for this campus
        this.showDesignationSettings = !!(
          this.designationSetting &&
          this.designationSetting.valueBool !== false
        );

        if (this.designationSetting && this.designationSetting.value) {
          this.designations = this.normalizeDesignations(
            this.designationSetting.value
          );
        } else {
          this.designations = [];
        }
        this.designationsLoaded = true;
      } catch (error) {
        console.error("Error loading designation settings:", error);
        this.designations = [];
        this.showDesignationSettings = false;
      } finally {
        this.loadingDesignationSettings = false;
      }
    },
    testClick() {
      console.log("Designation Settings button clicked");
      this.openDesignationSettings();
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.toolbar-row {
  margin-bottom: 1.5rem !important;

  // Ensure proper spacing between toolbar and table
  & + .row {
    margin-top: 0.5rem;
  }
}

// Additional spacing for better visual separation
.b-table {
  margin-top: 0.5rem !important;
}

// Ensure proper spacing between different sections
.row + .row {
  margin-top: 0.25rem;
}

.filter-button {
  height: 38px; // Match the height of the search input group
  font-weight: 500;

  &:hover {
    background-color: #6f42c1;
    border-color: #6f42c1;
    color: white;
  }

  &:focus {
    box-shadow: 0 0 0 0.2rem rgba(111, 66, 193, 0.25);
  }
}

.import-export-btn {
  height: 38px;
  width: 38px;

  &:hover {
    background-color: #6f42c1;
    border-color: #6f42c1;
    color: white;
  }

  &:focus {
    box-shadow: 0 0 0 0.2rem rgba(111, 66, 193, 0.25);
  }
}

// Ensure consistent height for all form elements in the toolbar
.vs__dropdown-toggle {
  min-height: 38px;
}

.form-control {
  height: 38px;
}

// Fix search icon alignment
.input-group-prepend {
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;

  .input-group-text {
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 0;
  }
}

.input-group-append {
  height: 38px;
  display: flex;
  align-items: center;
}

.search-criteria-dropdown {
  .btn {
    border-left: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    font-weight: 500;
    min-width: 120px;
    text-transform: capitalize;

    &:hover {
      background-color: #6f42c1;
      border-color: #6f42c1;
    }

    &:focus {
      box-shadow: 0 0 0 0.2rem rgba(111, 66, 193, 0.25);
    }
  }

  .dropdown-menu {
    border: 1px solid #e9ecef;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    border-radius: 0.375rem;
  }

  .dropdown-item {
    padding: 0.75rem 1rem;
    font-weight: 500;

    &:hover {
      background-color: #f8f9fa;
      color: #6f42c1;

      .text-muted {
        color: #6c757d !important;
      }
    }

    &.active {
      background-color: #6f42c1;
      color: white;

      .text-muted {
        color: rgba(255, 255, 255, 0.8) !important;
      }
    }
  }

  .search-criteria-item {
    .text-muted {
      font-size: 0.75rem;
      margin-top: 0.125rem;
    }
  }

  .dropdown-header {
    font-size: 0.875rem;
    font-weight: 400;
    color: #000000 !important;
    padding: 0.5rem 1rem 0.25rem;
    border-bottom: 1px solid #e9ecef;
    margin-bottom: 0.25rem;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
.card {
  transition: 0.4s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.rotate-table.table-responsive {
  transform: rotateX(180deg);
}
.rotate-table.table-responsive > ::v-deep.table {
  transform: rotateX(180deg);
}
/* adjust color on selection */
.table-responsive
  > ::v-deep.b-table
  > tbody
  .b-table-row-selected.table-active
  td.b-table-sticky-column {
  background-color: inherit !important;
}
/* no sticky column on smaller screen */
@media (max-width: 768px) {
  .table-responsive
    > ::v-deep.table.b-table
    > tbody
    > tr
    > .b-table-sticky-column {
    position: static !important;
  }
}

/* Designation Settings Styles */
.designation-list {
  max-height: calc(100vh - 280px);
  overflow-y: auto;
}

.designation-row {
  background: #fff;
}

.designation-row .btn-icon {
  width: 28px !important;
  height: 28px !important;
  padding: 0 !important;
}

.designation-row .badge {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
}

.designation-dept-select ::v-deep .vs__selected {
  font-weight: 600;
  color: #5e5873;
}

/* Bulk increment summary */
.bulk-inc-summary__stats .summary-stat {
  border-radius: 8px;
  padding: 12px 14px;
  height: 100%;
  border: 1px solid #ebe9f1;
  background: #fff;
}
.summary-stat__label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #6e6b7b;
  margin-bottom: 4px;
}
.summary-stat__value {
  display: block;
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1.2;
  color: #5e5873;
}
.summary-stat--primary {
  border-left: 3px solid #7367f0;
}
.summary-stat--muted {
  border-left: 3px solid #b9b9c3;
}
.summary-stat--accent {
  border-left: 3px solid #28c76f;
  background: linear-gradient(135deg, #f8fff9 0%, #fff 100%);
}
.summary-stat--warn {
  border-left: 3px solid #ff9f43;
  background: #fffaf3;
}
.bulk-inc-modal--import ::v-deep .modal-dialog,
.bulk-inc-modal--summary-compact ::v-deep .modal-dialog {
  max-width: 640px;
}

.bulk-inc-import-form {
  max-width: 100%;
}

.import-parse-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.import-parse-stat {
  flex: 1 1 140px;
  border-radius: 8px;
  padding: 10px 12px;
  border: 1px solid #ebe9f1;
  text-align: center;
}
.import-parse-stat--ready {
  background: #f3f0ff;
  border-color: #dcd6ff;
}
.import-parse-stat--skip {
  background: #f8f8f8;
  border-color: #ebe9f1;
}
.import-parse-stat--inc {
  background: #f6fff9;
  border-color: #c3f0d3;
}
.import-parse-stat--file-skip {
  background: #fff8ef;
  border-color: #ffe8c8;
}
.import-parse-stat--inc .import-parse-stat__num {
  font-size: 1.05rem;
}
.import-parse-stat__num {
  display: block;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.2;
  color: #5e5873;
}
.import-parse-stat--ready .import-parse-stat__num {
  color: #7367f0;
}
.import-parse-stat--skip .import-parse-stat__num {
  color: #ff9f43;
}
.import-parse-stat__lbl {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #6e6b7b;
  margin-top: 2px;
}

.summary-total-inline {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #f8f8f8;
  border: 1px solid #ebe9f1;
  font-size: 13px;
}
.summary-total-inline__label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #6e6b7b;
  width: 100%;
  margin-bottom: 2px;
}
@media (min-width: 576px) {
  .summary-total-inline__label {
    width: auto;
    margin-bottom: 0;
  }
}
.summary-total-inline__val {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #5e5873;
}
.summary-total-inline__val--new {
  color: #7367f0;
}
.summary-total-inline__arrow {
  color: #b9b9c3;
  flex-shrink: 0;
}
.bulk-inc-summary--compact {
  font-size: 13px;
}

.import-preview-table {
  max-height: 280px;
}
.bulk-inc-preview-table ::v-deep thead th {
  font-size: 11px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.bulk-inc-preview-table ::v-deep tbody td {
  font-size: 13px;
  padding-top: 0.45rem;
  padding-bottom: 0.45rem;
}

.summary-total-card {
  border: 1px solid #ebe9f1;
  border-radius: 8px;
  padding: 14px 16px;
  background: #f8f8f8;
}
.summary-total-card__title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6e6b7b;
  margin-bottom: 10px;
}
.summary-total-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  align-items: center;
}
@media (min-width: 768px) {
  .summary-total-grid {
    grid-template-columns: 1fr auto 1fr auto;
  }
}
.summary-total-item {
  text-align: center;
  padding: 8px 10px;
  border-radius: 6px;
  background: #fff;
  border: 1px dashed #dcdce4;
}
.summary-total-item--inc {
  border-color: #c3f0d3;
  background: #f6fff9;
}
.summary-total-card__arrow {
  color: #b9b9c3;
  flex-shrink: 0;
  justify-self: center;
}
.summary-salary-tag {
  display: inline-block;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #6e6b7b;
  background: #efefef;
  border-radius: 4px;
  padding: 2px 8px;
  margin-bottom: 6px;
}
.summary-salary-tag--new {
  color: #7367f0;
  background: #f0eeff;
}
.summary-salary-tag--inc {
  color: #28a745;
  background: #e8f8ee;
}
.summary-salary-tag--th {
  display: block;
  margin-bottom: 2px;
  font-size: 9px;
}
.summary-salary-tag--cell {
  display: block;
  margin-bottom: 2px;
  font-size: 9px;
  padding: 1px 6px;
}
.summary-th-stack {
  line-height: 1.25;
  font-weight: 700;
}
.summary-amount-cell {
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.summary-money {
  font-size: 1.05rem;
  font-weight: 600;
  color: #5e5873;
  font-variant-numeric: tabular-nums;
}
.summary-money--new {
  color: #7367f0;
}

.summary-table-wrap {
  border: 1px solid #ebe9f1;
  border-radius: 8px;
  overflow: hidden;
}
.bulk-inc-summary-table ::v-deep thead th {
  background: #f3f2f7 !important;
  border-bottom: 1px solid #ebe9f1 !important;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #6e6b7b;
  vertical-align: middle;
  white-space: nowrap;
}
.bulk-inc-summary-table ::v-deep tbody td {
  font-size: 13px;
  vertical-align: middle;
  font-variant-numeric: tabular-nums;
}
.bulk-inc-summary-table ::v-deep tbody tr:hover {
  background-color: #fafafa;
}
</style>
